var multiselect;
(function (multiselect) {
    var MultiSelectButtonCtrl = (function () {
        function MultiSelectButtonCtrl(s, e) {
        }
        MultiSelectButtonCtrl.$inject = ['$scope', '$element'];
        return MultiSelectButtonCtrl;
    }());
    multiselect.MultiSelectButtonCtrl = MultiSelectButtonCtrl;
    var MultiSelectButton = (function () {
        function MultiSelectButton($compile, filterFilter, $rootScope) {
            var _this = this;
            this.$compile = $compile;
            this.filterFilter = filterFilter;
            this.$rootScope = $rootScope;
            this.restrict = 'AE';
            this.require = 'ngModel';
            this.replace = true;
            this.scope = {
                items: "=ngItems",
                selectedItems: "=ngModel",
                required: "=ngRequired",
                mapValue: "@ngMapValue",
                mapSelected: "@ngMapSelected",
                isDropDown: "@ngIsDropDown",
                label: "@ngLabel",
                listFilter: "@ngMultiselectFilter"
            };
            this.controller = MultiSelectButtonCtrl;
            this.link = function (s, e, a, c) {
                var _self = _this;
                var options = JSON.parse(a["ngMultiSelectButton"] || "{}");
                if (!s.listFilter) {
                    s.listFilter = function (item) { return item.name; };
                }
                // pokazanie tylko listy wartości
                s.showAll = options.showAll || false;
                s.internalSelectedItems = [];
                s.notReady = true;
                s.levels1 = [];
                s.filteredLevels1 = [];
                s.levels2 = {};
                s.filteredLevels2 = {};
                s.searchPhrase = "";
                //s.selectedItems = [];
                s.selectedInfo = (s.label ? s.label : "wszystkie");
                // walidotor reuire
                if (s.required) {
                    c.$validators.required = function (mv, v) {
                        return (s.selectedItems.length > 0);
                    };
                }
                // fraza
                s.$watch("searchPhrase", function (n, o) {
                    if (n !== o) {
                        s.doPrepareLevel1();
                        s.doPrepareLevel2();
                    }
                });
                // listener
                s.onSearchPhraseChanged = function (searchPhrase) {
                    s.searchPhrase = searchPhrase;
                };
                // przygotowanie poziom 1
                s.doPrepareLevel1 = function () {
                    s.filteredLevels1 = [];
                    s.filteredLevels1 = _self.filterFilter(s.levels1, s.doFilter);
                };
                // przygotowanie poziom 2
                s.doPrepareLevel2 = function () {
                    angular.forEach(s.levels2, function (v, k) {
                        var _level = s.filteredLevels2[k];
                        if (!_level)
                            _level = { expanded: v.expanded, selected: v.selected, filteredItems: [] };
                        _level.filteredItems = _self.filterFilter(v.items, s.doFilter);
                        s.filteredLevels2[k] = _level;
                    });
                };
                // filter
                s.doFilter = function (item) {
                    var _search = (s.searchPhrase || "").toLowerCase();
                    if ((item.name || "").toLowerCase().indexOf(_search) === -1)
                        return false;
                    return true;
                };
                // zbudowanie listy
                s.buildList = function (items) {
                    /*
                    if (typeof s.mapSelected === 'string')
                        s.internalSelectedItems = _.filter(s.filteredItems, function (i) {
                            return (i[s.mapSelected] == true);
                        });
                    else
                        s.internalSelectedItems = [];
                        */
                    // jak sa elementy
                    if (items.length >= 0) {
                        // pepare temaplte
                        var _html = "";
                        var msGroup = false;
                        var msGroupName = undefined;
                        s.notReady = false;
                        s.levels1 = [];
                        s.levels2 = {};
                        var _selectedItems_1 = [];
                        angular.forEach(items, function (i) {
                            if (i.msGroup === true && typeof i.name !== "undefined") {
                                // otwarcie grupy
                                msGroup = true;
                                msGroupName = i.name;
                                if (!s.levels2[msGroupName])
                                    s.levels2[msGroupName] = { expanded: false, selected: false, items: [], filteredItems: [] };
                            }
                            else if (msGroup === true && i.msGroup === false) {
                                // zamkniecie grupy
                                msGroup = false;
                                msGroupName = undefined;
                            }
                            else if (msGroup == true && typeof i.value !== "undefined" && typeof i.name !== "undefined") {
                                // dodawanie elementow w grupie
                                var isSelected = s.isElementSelectedByDefault(i);
                                var item = { name: i.name, value: i.value, selected: isSelected };
                                s.levels2[msGroupName].items.push(item);
                                if (item.selected === true)
                                    _selectedItems_1.push(item);
                            }
                            else if (msGroup === false && typeof i.value !== "undefined" && typeof i.name !== "undefined") {
                                // dodawanie elementow
                                var isSelected = s.isElementSelectedByDefault(i);
                                var item = { name: i.name, value: i.value, selected: isSelected };
                                s.levels1.push(item);
                                if (item.selected === true)
                                    _selectedItems_1.push(item);
                            }
                        });
                        // jak zaznaczone
                        s.internalSelectedItems = (_selectedItems_1 || []).slice();
                    }
                };
                // poziom 1
                s.$watch('levels1', function () {
                    s.doPrepareLevel1();
                });
                // poziom 2
                s.$watch('levels2', function () {
                    s.doPrepareLevel2();
                });
                // obiekty zewnetrzne
                s.$watch("items", function () {
                    s.buildList(s.items);
                });
                // obiekty wewnetrzne
                s.$watch("internalSelectedItems", function (n, o) {
                    if (n !== o) {
                        var _selectedItems = [];
                        if (typeof s.mapValue === 'string')
                            _selectedItems = _.map(s.internalSelectedItems, function (i) {
                                return i[s.mapValue];
                            });
                        else
                            _selectedItems = s.internalSelectedItems;
                        // zbadanie co jest a co nie
                        s.selectedItems = _selectedItems;
                        // wymagalnosc
                        if (s.required && c) {
                            c.$setValidity('required', (s.selectedItems.length > 0));
                        }
                        // napis na wyswietlaczu
                        s.selectedInfo = (s.selectedItems.length > 0 ? ("zaznaczono " + s.selectedItems.length) : (s.label ? s.label : "wszystkie"));
                    }
                }, true);
                // zaznaczenie itema
                s.addToSelected = function (item) {
                    var _self = this;
                    s.internalSelectedItems = s.internalSelectedItems || [];
                    if (s.internalSelectedItems.indexOf(item) === -1) {
                        s.internalSelectedItems.push(item);
                    }
                };
                // odznaczenie itema
                s.removeFromSelected = function (item) {
                    var _self = this;
                    s.internalSelectedItems = s.internalSelectedItems || [];
                    var _idx = s.internalSelectedItems.indexOf(item);
                    if (_idx !== -1)
                        s.internalSelectedItems.splice(_idx, 1);
                };
                // reagowanie na button "reset" z innego kontekstu
                var _resetListener = _this.$rootScope.$on('multiselect::reset', function (event, args) {
                    s.clearAll();
                });
                s.$on('$destroy', _resetListener);
                // klikanie po elementach
                s.toggleItem = function (item, group) {
                    if (item.selected === true) {
                        item.selected = !item.selected;
                        s.removeFromSelected(item);
                    }
                    else {
                        item.selected = !item.selected;
                        s.addToSelected(item);
                    }
                    // jak grupa
                    if (group && item.selected === false) {
                        var g = s.filteredLevels2[group] || { expanded: true, selected: true, items: [], filteredItems: [] };
                        g.selected = false;
                    }
                };
                // zaznaczenie grupu
                s.toggleAll = function (group) {
                    var g = s.filteredLevels2[group] || { expanded: true, selected: true, items: [], filteredItems: [] };
                    angular.forEach(g.filteredItems, function (i) {
                        i.selected = g.selected;
                        s.toggleItem(i);
                    });
                    g.selected = !g.selected;
                };
                // rozwijanie
                s.toggleExpand = function (group) {
                    var g = s.filteredLevels2[group] || { expanded: true, selected: true, items: [] };
                    g.expanded = !g.expanded;
                };
                // rozwijanie dropdown
                s.isDropDownVisible = false;
                s.toggleDropDown = function () {
                    s.isDropDownVisible = !s.isDropDownVisible;
                };
                // zaznaczenie
                s.isItemSelected = function (item) {
                    return item.selected;
                };
                // wyczyszczenia
                s.clearAll = function () {
                    var _selectedItems = s.internalSelectedItems;
                    for (var i = _selectedItems.length - 1; i >= 0; i--) {
                        s.toggleItem(_selectedItems[i]);
                    }
                };
                // pierwsze zaldowanie
                s.defaultSelectedItems = [];
                s.defaultSelectedItemsInited = false;
                s.$watch("defaultSelectedItems", function () {
                    s.buildList(s.items);
                });
                s.$watch("selectedItems", function () {
                    if (s.defaultSelectedItemsInited === false) {
                        s.defaultSelectedItems = (s.selectedItems || []).slice();
                        s.defaultSelectedItemsInited = true;
                    }
                });
                // sprawdzenie czy zaznaczony domyslnie
                s.isElementSelectedByDefault = function (item) {
                    if (typeof s.mapValue === "string") {
                        if (s.defaultSelectedItems.indexOf(item[s.mapValue]) !== -1)
                            return true;
                    }
                    return (s.defaultSelectedItems.indexOf(item) !== -1);
                };
            };
            this.template = "\n            <div class='emgMultiSelect'>\n                <span class='message' ng-if='notReady'>...</span>\n                \n                <!-- komponent -->\n                <div ng-if='notReady !== true'>\n\n                    <!-- guzik -->\n                    <div ng-if='isDropDown'>\n                        <div class='btn-group'>\n                            <button type='button' class='btn btn-default dropdown-toggle' data-toggle='dropdown'>\n                                <div class='drop-down-label'>{{selectedInfo}}</div><span class='caret'></span>\n                            </button>\n                        </div>\n                    </div>\n                    <!-- guzik end -->\n\n                    <!-- lista wartosci -->\n                    <div class=\"result-area\" ng-class='{\"drop-down-hidden\" : (showAll === false), \"drop-down\" : (isDropDown)}'>\n                        <div class='input-group searchPanel'  ng-init=\"_searchPhrase = searchPhrase\">\n                            <input type=\"text\" name=\"searchPhrase\" class=\"form-control\" ng-model=\"_searchPhrase\" ng-change=\"onSearchPhraseChanged(_searchPhrase)\" placeholder=\"Szukaj...\"/>\n                            <span class=\"input-group-addon clear-all-button\" ng-click=\"clearAll();_searchPhrase = '';\">X</span>\n                        </div>\n                        \n                        <!-- lista -->\n                        <div class='result'>\n                            \n                            <!-- level 1 -->\n                            <div class='levels1'>\n                                <div class='levels1-item clearfix' ng-repeat=\"i in filteredLevels1\" ng-click='toggleItem(i)'>\n                                    <div class='levels1-item-label'>{{i.name}}</div>\n                                    <div class='levels1-item-check'><input type='checkbox' value={{i.value}} name='values[]' ng-checked='isItemSelected(i)'/></div>\n                                </div>\n                            </div>\n                            <!-- level 1 end -->\n                            \n                            <!-- level 2 -->\n                            <div class='levels2' ng-repeat=\"(k,v) in filteredLevels2\">\n                                <h5 class='levels2-header clearfix'  ng-if='v.filteredItems.length > 0'>\n                                    <div class='levels2-header-label' ng-click='toggleExpand(k)'>{{k}} ({{ v.filteredItems.length }})</div>\n                                    <div class='levels2-header-check'><input type='checkbox' value={{k}} name='header' ng-checked='isItemSelected(v)' ng-click='toggleAll(k)'/></div>\n                                </h5>\n\n                                <div class='levels2-items'>\n                                    <div ng-class=\"{hidden:( v.expanded !== true )}\" class='levels2-item clearfix' ng-repeat=\"i in v.filteredItems\" ng-click='toggleItem(i, k)'>\n                                        <div class='levels2-item-label'>{{i.name}}</div>\n                                        <div class='levels2-item-check'><input type='checkbox' value={{i.value}} name='values[]' ng-checked='isItemSelected(i)'/></div>\n                                    </div>\n                                </div>\n                            </div>\n                            <!-- level 2 end -->\n                            \n                            \n                        </div>\n                        <!-- lista end -->\n                                                \n                    </div>\n                    <!-- lista wartosci end -->\n\n                </div>\n                <!-- komponent end-->\n            </div>\n            ";
        }
        MultiSelectButton.Factory = function () {
            var dir = function ($compile, filterFilter, $rootScope) {
                return new MultiSelectButton($compile, filterFilter, $rootScope);
            };
            dir['$inject'] = ['$compile', 'filterFilter', '$rootScope'
            ];
            return dir;
        };
        ;
        ;
        return MultiSelectButton;
    }());
    multiselect.MultiSelectButton = MultiSelectButton;
    ;
})(multiselect || (multiselect = {}));
var systemAdmin;
(function (systemAdmin) {
    // główny panel administracyjny
    var SystemPanelDirective = (function () {
        function SystemPanelDirective() {
            this.templateUrl = '/WWW/partials/modules/admin/system.panel.html';
            this.controller = "SystemCtrl";
            this.scope = {
                user: "=",
                requestId: "=",
                isAdmin: "=",
                partner: "=",
                settings: "="
            };
        }
        ;
        SystemPanelDirective.Factory = function () {
            var d = function () { return new SystemPanelDirective(); };
            d['$inject'] = [];
            return d;
        };
        return SystemPanelDirective;
    }());
    systemAdmin.SystemPanelDirective = SystemPanelDirective;
    // lista statusow
    var SystemPanelProcessStatusChangeListCtrl = (function () {
        function SystemPanelProcessStatusChangeListCtrl($scope) {
        }
        SystemPanelProcessStatusChangeListCtrl.$inject = ['$scope'];
        return SystemPanelProcessStatusChangeListCtrl;
    }());
    var SystemPanelProcessStatusChangeListDirective = (function () {
        function SystemPanelProcessStatusChangeListDirective() {
            this.template = "\n        <div class=\"processStatusChangeList\">\n        <h3>Lista zmian status\u00F3w</h3>\n        <!-- lista zmian status\u00F3w -->\n        <table class=\"table table-bordered table-striped\">\n            <thead>\n                <tr>\n                    <th>Zmieni\u0142</th>\n                    <th>Poprzedni status</th>\n                    <th>Status po zmianie</th>\n                    <th>Data zmiany</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat=\"statusChange in process.StatusChanges | orderBy:'WhenChanged'\">\n                    <td>{{statusChange.ChangedBy | Empty}}</td>\n                    <td>{{statusChange.FromStatus | ProcessStatusFilter | Empty}}</td>\n                    <td>{{statusChange.CurrentStatus | ProcessStatusFilter | Empty}}</td>\n                    <td>{{statusChange.WhenChanged | AspDateTime | Empty}}</td>\n                </tr>\n            </tbody>\n        </table>\n        </div>\n        ";
            this.controller = SystemPanelProcessStatusChangeListCtrl;
            this.scope = {
                process: "="
            };
        }
        ;
        SystemPanelProcessStatusChangeListDirective.Factory = function () {
            var d = function () { return new SystemPanelProcessStatusChangeListDirective(); };
            d['$inject'] = [];
            return d;
        };
        return SystemPanelProcessStatusChangeListDirective;
    }());
    systemAdmin.SystemPanelProcessStatusChangeListDirective = SystemPanelProcessStatusChangeListDirective;
    var SystemPanelProcessPartnerChangeListCtrl = (function () {
        function SystemPanelProcessPartnerChangeListCtrl($scope) {
        }
        SystemPanelProcessPartnerChangeListCtrl.$inject = ['$scope'];
        return SystemPanelProcessPartnerChangeListCtrl;
    }());
    var SystemPanelProcessPartnerChangeListDirective = (function () {
        function SystemPanelProcessPartnerChangeListDirective() {
            this.template = "\n                <div class=\"processPartnerChangeList\">\n                <h3>Lista zmian partner\u00F3w</h3>\n                <!-- lista zmian status\u00F3w -->\n                <table class=\"table table-bordered table-striped\">\n                    <thead>\n                        <tr>\n                            <th>Zmieni\u0142</th>\n                            <th>Poprzedni partner</th>\n                            <th>Partner po zmianie</th>\n                            <th>Data zmiany</th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <tr ng-repeat=\"operatorChange in process.RequestOperatorChange | orderBy:'DateModified'\">\n                            <td>{{operatorChange.ChangedBy | Empty}}</td>\n                            <td>{{operatorChange.PreviousOperatorPartner}}</td>\n                            <td>{{operatorChange.NewOperatorPartner}}</td>\n                            <td>{{operatorChange.DateModified | AspDateTime | Empty}}</td>\n                        </tr>\n                    </tbody>\n                </table>\n                </div>\n                ";
            this.controller = SystemPanelProcessPartnerChangeListCtrl;
            this.scope = {
                process: "="
            };
        }
        ;
        SystemPanelProcessPartnerChangeListDirective.Factory = function () {
            var d = function () { return new SystemPanelProcessPartnerChangeListDirective(); };
            d['$inject'] = [];
            return d;
        };
        return SystemPanelProcessPartnerChangeListDirective;
    }());
    systemAdmin.SystemPanelProcessPartnerChangeListDirective = SystemPanelProcessPartnerChangeListDirective;
    // pomocnik
    var SystemPanelAdminHelperSrv = (function () {
        function SystemPanelAdminHelperSrv() {
            var _this = this;
            this.currentFilter = undefined;
            this.setCurrentFilter = function (filter) {
                var _self = _this;
                _self.currentFilter = JSON.stringify(filter);
            };
            this.getCurrentFilter = function () {
                var _self = _this;
                return _self.currentFilter;
            };
        }
        ;
        SystemPanelAdminHelperSrv.$inject = [];
        return SystemPanelAdminHelperSrv;
    }());
    systemAdmin.SystemPanelAdminHelperSrv = SystemPanelAdminHelperSrv;
    // kontroller do raportow
    var SystemPanelReportCtrl = (function () {
        function SystemPanelReportCtrl($scope, $window, SystemPanelAdminHelperSrv) {
            // pobranie raportu wg filtrow
            $scope.GenerateProcessWorksheetByCurrentFilter = function () {
                var filterJson = SystemPanelAdminHelperSrv.getCurrentFilter();
                $window.open('/File/GenerateWorksheetSummaryByCurrentFilter?filterJson=' + filterJson);
            };
            // pobranie zetsawienia
            $scope.GenerateProcessWorksheet = function () {
                var filterJson = SystemPanelAdminHelperSrv.getCurrentFilter();
                $window.open('/File/GenerateWorksheetSummary?filterJson=' + filterJson);
            };
        }
        SystemPanelReportCtrl.$inject = ['$scope', '$window', 'SystemPanelAdminHelperSrv'];
        return SystemPanelReportCtrl;
    }());
    systemAdmin.SystemPanelReportCtrl = SystemPanelReportCtrl;
    var ProcessTypeNameDir = (function () {
        function ProcessTypeNameDir() {
            this.scope = {
                type: "="
            };
            this.restrict = 'E';
            this.template = "\n        <div>\n        <!--\n        <span class=\"label label-warning\" style=\"color: black;\" ng-if=\"type === 'FinancialLeasing'\">l.finansowy</span>\n        -->\n        <span class=\"label label-warning\" style=\"color: black;\" ng-if=\"type === 'OperationalLeasing'\">l.operacyjny</span>\n        <span class=\"label label-warning\" style=\"color: black;\" ng-if=\"type === 'Loan'\">po\u017Cyczka / l.finansowy</span>\n        <span class=\"label label-warning\" style=\"color: black;\" ng-if=\"type === 'Common' || !type || type === ''\">inne</span>\n        </div>\n        ";
            this.link = function (scope, elem, attr) {
            };
        }
        ProcessTypeNameDir.Factory = function () {
            var d = function () { return new ProcessTypeNameDir(); };
            return d;
        };
        return ProcessTypeNameDir;
    }());
    systemAdmin.ProcessTypeNameDir = ProcessTypeNameDir;
    // dodanie informacji o fraud
    var SystemFraudSrv = (function () {
        function SystemFraudSrv($http, $q) {
            var _this = this;
            this.$http = $http;
            this.$q = $q;
            this.getData = function (id) {
                var url = '/api/OfferFraudReport/' + id;
                return _this.$http.get(url);
            };
            this.sendData = function (id) {
                var url = '/api/OfferFraudReport/' + id;
                return _this.$http.put(url, { id: id, request: "send" });
            };
            this.checkData = function (id) {
                var url = '/api/OfferFraudReport/' + id;
                return _this.$http.put(url, { id: id, request: "check" });
            };
        }
        SystemFraudSrv.$inject = ['$http', '$q'];
        return SystemFraudSrv;
    }());
    systemAdmin.SystemFraudSrv = SystemFraudSrv;
    var SystemFraudCtrl = (function () {
        function SystemFraudCtrl($scope, service, toaster, $timeout) {
            this.$scope = $scope;
            this.service = service;
            this.toaster = toaster;
            this.$timeout = $timeout;
            // pobranie informacji
            $scope.refresh = function () {
                service.getData($scope.processId).then(function (d) {
                    $scope.items = d.data.Result || [];
                });
            };
            // wyslanie ponownie
            $scope.sendAgain = function () {
                service.sendData($scope.processId).then(function (d) {
                    toaster.pop('success', 'Operacja powiodła się');
                    $timeout(function () {
                        $scope.refresh();
                    }, 2000);
                });
            };
            // sprawdzenie ponownie
            $scope.checkAgain = function () {
                service.checkData($scope.processId).then(function (d) {
                    toaster.pop('success', 'Operacja powiodła się');
                    $scope.refresh();
                });
            };
            //
            $scope.items = [];
            $scope.refresh();
        }
        SystemFraudCtrl.$inject = ['$scope', 'SystemFraudSrv', 'toaster', '$timeout'];
        return SystemFraudCtrl;
    }());
    var SystemFraudDirective = (function () {
        function SystemFraudDirective() {
            this.controller = SystemFraudCtrl;
            this.restrict = 'AE';
            this.template = "\n<div class=\"fraud-detection-reports-container\">\n\n<div class=\"text-right\">\n<button class=\"btn btn-sm btn-default\" ng-click=\"sendAgain()\">wy\u015Blij ponownie</button>\n<!-- button class=\"btn btn-sm btn-default\" ng-click=\"checkAgain()\">sprawd\u017A</button -->\n</div>\n\n<br/>\n\n<table class=\"table\">\n<tr ng-repeat=\"item in items track by $index\">\n<td>{{item.fraudstatus}}</td>\n<td>{{item.description}}</td>\n<td>{{item.timestamp | AspDateTime}}</td>\n</tr>\n</table>\n\n\n\n</div>\n        ";
            this.scope = {
                processId: "="
            };
        }
        SystemFraudDirective.Factory = function () {
            var d = function () { return new SystemFraudDirective(); };
            return d;
        };
        return SystemFraudDirective;
    }());
    systemAdmin.SystemFraudDirective = SystemFraudDirective;
    // notatki do oferty
    var SystemOfferNoteSrv = (function () {
        function SystemOfferNoteSrv($http, $q) {
            var _this = this;
            this.$http = $http;
            this.$q = $q;
            this.listAll = function (processId) {
                var url = '/api/OfferNotes?offerGuid=' + processId;
                return _this.$http.get(url);
            };
            this.getData = function (id) {
                var url = '/api/OfferFraudReport/' + id;
                return _this.$http.get(url);
            };
            this.saveData = function (item) {
                var url = '/api/OfferNotes';
                return _this.$http.post(url, item);
            };
            this.updateData = function (item) {
                var url = '/api/OfferNotes/' + item.Guid;
                return _this.$http.put(url, item);
            };
        }
        SystemOfferNoteSrv.$inject = ['$http', '$q'];
        return SystemOfferNoteSrv;
    }());
    systemAdmin.SystemOfferNoteSrv = SystemOfferNoteSrv;
    var SystemOfferNoteCtrl = (function () {
        function SystemOfferNoteCtrl($scope, service, toaster, $modal) {
            this.$scope = $scope;
            this.service = service;
            this.toaster = toaster;
            this.$modal = $modal;
            // pobranie informacji
            $scope.refresh = function () {
                service.listAll($scope.process.OfferClientResonse_Guid).then(function (d) {
                    $scope.Notes = d.data.Result || [];
                });
            };
            // dodanie notatki
            $scope.AddNote = function () {
                var offerId = $scope.process.OfferClientResonse_Guid;
                var modalInstance = $modal.open({
                    animation: true,
                    templateUrl: '/WWW/partials/noteForm.html',
                    controller: 'NoteFormCtrl',
                    resolve: {
                        OfferGuid: function () {
                            return offerId;
                        },
                        Item: function () {
                            return "";
                        },
                        PartnerName: function () {
                            return $scope.user.Partner;
                        }
                    }
                });
                modalInstance.result.then(function (item) {
                    service.saveData(item).then(function (d) {
                        toaster.pop('success', 'Operacja powiodła się');
                        $scope.refresh();
                    });
                });
            };
            // edycja notatki
            $scope.EditNote = function (item) {
                var offerId = $scope.process.OfferClientResonse_Guid;
                var modalInstance = $modal.open({
                    animation: true,
                    templateUrl: '/WWW/partials/noteForm.html',
                    controller: 'NoteFormCtrl',
                    resolve: {
                        OfferGuid: function () {
                            return offerId;
                        },
                        Item: function () {
                            return item;
                        },
                        PartnerName: function () {
                            return $scope.user.Partner;
                        }
                    }
                });
                modalInstance.result.then(function (item) {
                    service.updateData(item).then(function (d) {
                        toaster.pop('success', 'Operacja powiodła się');
                        $scope.refresh();
                    });
                });
            };
            //
            $scope.Notes = [];
            $scope.refresh();
        }
        SystemOfferNoteCtrl.$inject = ['$scope', 'SystemOfferNoteSrv', 'toaster', '$modal'];
        return SystemOfferNoteCtrl;
    }());
    var SystemOfferNoteDirective = (function () {
        function SystemOfferNoteDirective() {
            this.controller = SystemOfferNoteCtrl;
            this.restrict = 'AE';
            this.templateUrl = '/WWW/partials/request/requestOfferNotesList.html';
            this.scope = {
                process: "=",
                user: "="
            };
        }
        SystemOfferNoteDirective.Factory = function () {
            var d = function () { return new SystemOfferNoteDirective(); };
            return d;
        };
        return SystemOfferNoteDirective;
    }());
    systemAdmin.SystemOfferNoteDirective = SystemOfferNoteDirective;
    // serwis do pobierania i sprawdzania potwierdzen transakcji DotPay
    var SystemPanelOfferPaymentConfirmationSrv = (function () {
        function SystemPanelOfferPaymentConfirmationSrv($http, $q) {
            var _this = this;
            this.$http = $http;
            this.$q = $q;
            // pobranie potwierdzen
            this.getPayments = function (id) {
                var url = '/api/BusinessProcessPaymentConfirmation/' + id;
                return _this.$http.get(url);
            };
            // sprawdzenie potwierdzenia
            this.checkPayment = function (id, confirmationId) {
                var url = '/api/BusinessProcessPaymentConfirmation/' + id;
                return _this.$http.put(url, { confirmationId: confirmationId });
            };
        }
        SystemPanelOfferPaymentConfirmationSrv.$inject = ['$http', '$q'];
        return SystemPanelOfferPaymentConfirmationSrv;
    }());
    systemAdmin.SystemPanelOfferPaymentConfirmationSrv = SystemPanelOfferPaymentConfirmationSrv;
    // kontroler do pobierania i sprawdzania potwierdzen transakcji DotPay
    var SystemPanelOfferPaymentConfirmationCtrl = (function () {
        function SystemPanelOfferPaymentConfirmationCtrl($scope, service, toaster) {
            this.$scope = $scope;
            this.service = service;
            this.toaster = toaster;
            // model
            $scope.paymentConfirmations = [];
            // pobranie potwierdzen
            $scope.getPayments = function () {
                service.getPayments($scope.offerId)
                    .then(function (d) {
                    $scope.paymentConfirmations = d.data.Result || [];
                });
            };
            // sprawdzenie potwierdzenia
            $scope.checkPayment = function (confirmationId) {
                service.checkPayment($scope.offerId, confirmationId)
                    .then(function (d) {
                    toaster.pop('success', 'Operacja powiodła się');
                    $scope.getPayments();
                });
            };
            // pobierz potwierdzenia
            $scope.getPayments();
        }
        SystemPanelOfferPaymentConfirmationCtrl.$inject = ['$scope', 'SystemPanelOfferPaymentConfirmationSrv', 'toaster'];
        return SystemPanelOfferPaymentConfirmationCtrl;
    }());
    // dyrektywa do wyswietlania i zarzadzania potwierdzeniami transakcji DotPay
    var SystemPanelOfferPaymentConfirmationDirective = (function () {
        function SystemPanelOfferPaymentConfirmationDirective() {
            this.template = "\n            <!-- lista transakcji-->\n            <h4>Lista transakcji</h4>\n            <table class=\"table table-bordered table-striped\">\n                <thead>\n                    <tr>\n                        <th>Numer transakcji</th>\n                        <th>Data/czas transakcji</th>\n                        <th>Kwota</th>\n                        <th>Status</th>\n                        <th>Akcja</th>\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr ng-repeat=\"payment in paymentConfirmations\">\n                        <td>\n                            {{ payment.t_id | Empty }}<br />\n                            <span style=\"font-size: smaller\">{{ payment.description }}</span>\n                        </td>\n                        <td>{{ payment.t_date | Empty }}</td>\n                        <td>{{ payment.orginal_amount | Empty }}</td>\n                        <td title=\"{{ payment.status | Empty }} | {{ payment.t_status | Empty}}\">{{ payment.t_status_desc | Empty }}</td>\n                        <td>\n                            <button class=\"btn btn-sm btn-default\" ng-click=\"checkPayment(payment.t_id)\">Sprawd\u017A</button>\n                        </td>\n                    </tr>\n                </tbody>\n            </table>\n        ";
            this.controller = SystemPanelOfferPaymentConfirmationCtrl;
            this.scope = {
                offerId: "="
            };
        }
        ;
        SystemPanelOfferPaymentConfirmationDirective.Factory = function () {
            var d = function () { return new SystemPanelOfferPaymentConfirmationDirective(); };
            d['$inject'] = [];
            return d;
        };
        return SystemPanelOfferPaymentConfirmationDirective;
    }());
    systemAdmin.SystemPanelOfferPaymentConfirmationDirective = SystemPanelOfferPaymentConfirmationDirective;
    // rekordy audytowe
    var SystemPanelUserAuditSrv = (function () {
        function SystemPanelUserAuditSrv($http, $q) {
            var _this = this;
            this.$http = $http;
            this.$q = $q;
            // pobranie potwierdzen
            this.getUserAudits = function (id) {
                var url = '/api/BusinessProcessUserAudit/' + id;
                return _this.$http.get(url);
            };
        }
        SystemPanelUserAuditSrv.$inject = ['$http', '$q'];
        return SystemPanelUserAuditSrv;
    }());
    systemAdmin.SystemPanelUserAuditSrv = SystemPanelUserAuditSrv;
    var SystemPanelUserAuditCtrl = (function () {
        function SystemPanelUserAuditCtrl($scope, service, toaster) {
            this.$scope = $scope;
            this.service = service;
            this.toaster = toaster;
            // model
            $scope.userAudits = [];
            // pobranie potwierdzen
            $scope.getUserAudits = function () {
                service.getUserAudits($scope.process.OfferClientResonse_Guid)
                    .then(function (d) {
                    $scope.userAudits = d.data.Result || [];
                });
            };
            // pobierz potwierdzenia
            $scope.getUserAudits();
        }
        SystemPanelUserAuditCtrl.$inject = ['$scope', 'SystemPanelUserAuditSrv', 'toaster'];
        return SystemPanelUserAuditCtrl;
    }());
    var SystemPanelUserAuditDirective = (function () {
        function SystemPanelUserAuditDirective() {
            this.template = "\n\n               <h3>Lista akcji logowanych klienta</h3>\n\n                <!-- lista IP -->\n                <table class=\"table table-bordered table-striped\">\n                    <thead>\n                        <tr>\n                            <th>Akcja</th>\n                            <th>Agent</th>\n                            <th>IP</th>\n                            <th>Zmieni\u0142</th>\n                            <th>Data zmiany</th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <tr ng-repeat=\"audit in userAudits\">\n                            <td>{{audit.UserAction | Empty}}</td>\n                            <td>{{audit.UserAgent | Empty}}</td>\n                            <td>{{audit.UserIP | Empty}}</td>\n                            <td>{{audit.ChangedBy | Empty}}</td>\n                            <td>{{audit.WhenChanged | AspDateTime | Empty}}</td>\n                        </tr>\n                    </tbody>\n                </table>\n                ";
            this.controller = SystemPanelUserAuditCtrl;
            this.scope = {
                process: "=",
                user: "="
            };
        }
        ;
        SystemPanelUserAuditDirective.Factory = function () {
            var d = function () { return new SystemPanelUserAuditDirective(); };
            d['$inject'] = [];
            return d;
        };
        return SystemPanelUserAuditDirective;
    }());
    systemAdmin.SystemPanelUserAuditDirective = SystemPanelUserAuditDirective;
    // komunikaty
    var SystemPanelClientCommunicationHistorySrv = (function () {
        function SystemPanelClientCommunicationHistorySrv($http, $q) {
            var _this = this;
            this.$http = $http;
            this.$q = $q;
            // pobranie komunikatow
            this.getHistory = function (id) {
                var url = '/api/ClientCommunicationHistory/' + id;
                return _this.$http.get(url);
            };
        }
        SystemPanelClientCommunicationHistorySrv.$inject = ['$http', '$q'];
        return SystemPanelClientCommunicationHistorySrv;
    }());
    systemAdmin.SystemPanelClientCommunicationHistorySrv = SystemPanelClientCommunicationHistorySrv;
    var SystemPanelClientCommunicationHistoryCtrl = (function () {
        function SystemPanelClientCommunicationHistoryCtrl($scope, service, toaster) {
            this.$scope = $scope;
            this.service = service;
            this.toaster = toaster;
            // model
            $scope.history = [];
            // pobranie komunikatow
            $scope.getHistory = function () {
                service.getHistory($scope.process.OfferClientResonse_Guid)
                    .then(function (d) {
                    $scope.history = d.data.Result || [];
                });
            };
            // pobierz komunikatow
            $scope.getHistory();
        }
        SystemPanelClientCommunicationHistoryCtrl.$inject = ['$scope', 'SystemPanelClientCommunicationHistorySrv', 'toaster'];
        return SystemPanelClientCommunicationHistoryCtrl;
    }());
    var SystemPanelPanelClientCommunicationHistoryDirective = (function () {
        function SystemPanelPanelClientCommunicationHistoryDirective() {
            this.template = "\n            <h3>Lista SMS\u00F3w wys\u0142anych do klienta</h3>\n\n            <!-- wys\u0142ane SMSy -->\n            <table class=\"table table-bordered table-striped\">\n                <thead>\n                    <tr>\n                        <th>Odbiorca</th>\n                        <th>Sprawa</th>\n                        <th>Data wys\u0142ania</th>\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr ng-repeat=\"sms in history.SmsHistory\">\n                        <td>{{sms.Recipient | Empty}}</td>\n                        <td>{{sms.Subject | Empty}}</td>\n                        <td>{{sms.DateSent | AspDateTime | Empty}}</td>\n                    </tr>\n                </tbody>\n            </table>\n\n\n            <h3>Lista e-maili wys\u0142anych do klienta</h3>\n\n            <!-- wys\u0142ane maile -->\n            <table class=\"table table-bordered table-striped\">\n                <thead>\n                    <tr>\n                        <th>Odbiorca</th>\n                        <th>Temat</th>\n                        <th>Data wys\u0142ania</th>\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr ng-repeat=\"mail in history.MailHistory\">\n                        <td>{{mail.Recipient | Empty}}</td>\n                        <td>{{mail.Subject | Empty}}</td>\n                        <td>{{mail.DateSent | AspDateTime | Empty}}</td>\n                    </tr>\n                </tbody>\n            </table>";
            this.controller = SystemPanelClientCommunicationHistoryCtrl;
            this.scope = {
                process: "="
            };
        }
        ;
        SystemPanelPanelClientCommunicationHistoryDirective.Factory = function () {
            var d = function () { return new SystemPanelPanelClientCommunicationHistoryDirective(); };
            d['$inject'] = [];
            return d;
        };
        return SystemPanelPanelClientCommunicationHistoryDirective;
    }());
    systemAdmin.SystemPanelPanelClientCommunicationHistoryDirective = SystemPanelPanelClientCommunicationHistoryDirective;
    // logowanie i zmiana hasła
    var SystemLoginPanelCtrl = (function () {
        function SystemLoginPanelCtrl($scope) {
            // view domyślny
            $scope.currentView = 'LOGIN_FORM';
            // zmień na formatkę do zmiany hasła
            $scope.changeViewToResetPasswordForm = function () {
                $scope.currentView = 'RESET_PASSWORD_FORM';
            };
            // ustaw domyślne
            $scope.changeViewToLoginForm = function () {
                $scope.currentView = 'LOGIN_FORM';
            };
        }
        SystemLoginPanelCtrl.$inject = ['$scope'];
        return SystemLoginPanelCtrl;
    }());
    var SystemLoginAuthPanelCtrl = (function () {
        function SystemLoginAuthPanelCtrl($scope, $location, $http, toaster) {
            $scope.user = {
                login: "",
                password: ""
            };
            $scope.login = function () {
                $http.get("/system/login/af-token").then(function (result) {
                    var headers = {};
                    headers[result.data.headerName] = result.data.token;
                    $http.post("/system/partner/login", $scope.user, {
                        headers: headers
                    }).then(function (d) {
                        if (d.data.ChangePasswordOnLogon === true) {
                            toaster.pop('sucess', "Logowanie", "Witamy w systemie LeaseLink. Twoje konto użytkownika ma ustawione wymuszenie zmiany hasła przy logowaniu.");
                            $scope.$parent.currentView = 'CHANGE_PASSWORD_FORM';
                        }
                        else {
                            toaster.pop('sucess', "Logowanie", "Witamy w systemie LeaseLink");
                            top.location.href = "/system/index";
                        }
                    }, function (e) {
                        toaster.pop('error', "Logowanie", "Podane dane nie są poprawne.");
                    });
                }, function (e) {
                    toaster.pop('error', "Logowanie", "Podane dane nie są poprawne.");
                });
            };
            $scope.showLogin = false;
            $scope.toggleLoginHelp = function () {
                $scope.showLogin = !$scope.showLogin;
            };
            $scope.showPassword = false;
            $scope.togglePasswordHelp = function () {
                $scope.showPassword = !$scope.showPassword;
            };
        }
        ;
        SystemLoginAuthPanelCtrl.$inject = ['$scope', '$location', '$http', 'toaster'];
        return SystemLoginAuthPanelCtrl;
    }());
    var SystemLoginChangePasswordPanelCtrl = (function () {
        function SystemLoginChangePasswordPanelCtrl($scope, $location, $http, toaster) {
            $scope.item = {
                CurrentPassword: "",
                Password: "",
                PasswordConfirm: ""
            };
            // oddanie danych
            $scope.saveNewPassword = function () {
                $http.post("/system/password-reset-confirm", {
                    CurrentPassword: $scope.CurrentPassword,
                    Password: $scope.Password,
                    PasswordConfirm: $scope.PasswordConfirm,
                    ChangePaswordOnLogon: false
                }).then(function (d) {
                    toaster.pop('success', "Użytkownicy", "Poprawnie zmieniono hasło");
                    $scope.cancel();
                }, function (e) {
                    toaster.pop('error', "Użytkownicy", "Zmiana hasła nie powiodła się");
                });
            };
            // zamkniecie
            $scope.cancel = function () {
                $scope.$parent.currentView = 'LOGIN_FORM';
            };
        }
        ;
        SystemLoginChangePasswordPanelCtrl.$inject = ['$scope', '$location', '$http', 'toaster'];
        return SystemLoginChangePasswordPanelCtrl;
    }());
    // formatka do resetu hasła
    var SystemLoginResetPasswordPanelCtrl = (function () {
        function SystemLoginResetPasswordPanelCtrl($scope, $location, $http, toaster) {
            $scope.item = {
                Login: "",
                Channel: null
            };
            // oddanie danych
            $scope.resetPassword = function () {
                // póki nie ma podziału na SMS i email, na sztywno wybranie kanału 0 (email)
                $scope.Channel = 0;
                $http.post("/system/password-reset", {
                    Login: $scope.Login,
                    Channel: parseInt($scope.Channel)
                }).then(function (d) {
                    if ($scope.Channel === 0) {
                        toaster.pop('success', "Użytkownicy", "Jeżeli podany login jest poprawny, na e-mail przypisany do konta otrzymasz wiadomość z nowym hasłem.");
                    }
                    else if ($scope.Channel === 1) {
                        toaster.pop('success', "Użytkownicy", "Jeżeli podany login jest poprawny, na numer telefonu przypisany do konta otrzymasz wiadomość z nowym hasłem.");
                    }
                    $scope.cancel();
                }, function (e) {
                    toaster.pop('error', "Użytkownicy", "Resetowanie hasła nie powiodło się");
                });
            };
            // zamkniecie
            $scope.cancel = function () {
                $scope.$parent.currentView = 'LOGIN_FORM';
            };
        }
        ;
        SystemLoginResetPasswordPanelCtrl.$inject = ['$scope', '$location', '$http', 'toaster'];
        return SystemLoginResetPasswordPanelCtrl;
    }());
    // komponent logowania
    var SystemLoginAuthPanelDirective = (function () {
        function SystemLoginAuthPanelDirective() {
            this.templateUrl = '/WWW/partials/loginForm.html';
            this.controller = SystemLoginAuthPanelCtrl;
        }
        ;
        SystemLoginAuthPanelDirective.Factory = function () {
            var d = function () { return new SystemLoginAuthPanelDirective(); };
            d['$inject'] = [];
            return d;
        };
        return SystemLoginAuthPanelDirective;
    }());
    systemAdmin.SystemLoginAuthPanelDirective = SystemLoginAuthPanelDirective;
    // komponent zmiany hasła
    var SystemLoginChangePasswordPanelDirective = (function () {
        function SystemLoginChangePasswordPanelDirective() {
            this.templateUrl = '/WWW/partials/modules/users/changePassword.html';
            this.controller = SystemLoginChangePasswordPanelCtrl;
        }
        ;
        SystemLoginChangePasswordPanelDirective.Factory = function () {
            var d = function () { return new SystemLoginChangePasswordPanelDirective(); };
            d['$inject'] = [];
            return d;
        };
        return SystemLoginChangePasswordPanelDirective;
    }());
    systemAdmin.SystemLoginChangePasswordPanelDirective = SystemLoginChangePasswordPanelDirective;
    // komponent resetu hasła
    var SystemLoginResetPasswordPanelDirective = (function () {
        function SystemLoginResetPasswordPanelDirective() {
            this.templateUrl = '/WWW/partials/modules/users/resetPassword.html';
            this.controller = SystemLoginResetPasswordPanelCtrl;
        }
        ;
        SystemLoginResetPasswordPanelDirective.Factory = function () {
            var d = function () { return new SystemLoginResetPasswordPanelDirective(); };
            d['$inject'] = [];
            return d;
        };
        return SystemLoginResetPasswordPanelDirective;
    }());
    systemAdmin.SystemLoginResetPasswordPanelDirective = SystemLoginResetPasswordPanelDirective;
    // komponent autoryzacji
    var SystemLoginPanelDirective = (function () {
        function SystemLoginPanelDirective() {
            this.templateUrl = "/WWW/partials/modules/admin/system.panel.login.html";
            this.controller = SystemLoginPanelCtrl;
            this.scope = {
                okMessage: "@",
                failMessage: "@"
            };
            console.log(top.location.href);
        }
        ;
        SystemLoginPanelDirective.Factory = function () {
            var d = function () { return new SystemLoginPanelDirective(); };
            d['$inject'] = [];
            return d;
        };
        return SystemLoginPanelDirective;
    }());
    systemAdmin.SystemLoginPanelDirective = SystemLoginPanelDirective;
    // koponoent pokazywania skoringu
    var SystemScoringOutputSrv = (function () {
        function SystemScoringOutputSrv($http, $q) {
            var _this = this;
            this.$http = $http;
            this.$q = $q;
            // pobranie komunikatow
            this.getScoring = function (id) {
                var url = '/api/BusinessProcessScoring/' + id;
                return _this.$http.get(url);
            };
        }
        SystemScoringOutputSrv.$inject = ['$http', '$q'];
        return SystemScoringOutputSrv;
    }());
    systemAdmin.SystemScoringOutputSrv = SystemScoringOutputSrv;
    var SystemScoringOutputCtrl = (function () {
        function SystemScoringOutputCtrl($scope, $service) {
            var _this = this;
            this.$service = $service;
            //
            $scope.rules = [];
            $scope.processId = $scope.process.OfferClientResonse_Guid;
            //
            $scope.refreshRules = function () {
                _this
                    .$service
                    .getScoring($scope.processId)
                    .then(function (d) {
                    var result = d.data.Result;
                    var DecisionEngineResponseAsObject = result.DecisionEngineResponseAsObject;
                    if (DecisionEngineResponseAsObject) {
                        $scope.rules = DecisionEngineResponseAsObject.OutputRulesAsObject;
                    }
                });
            };
            //
            $scope.refreshRules();
        }
        SystemScoringOutputCtrl.$inject = ['$scope', 'SystemScoringOutputSrv'];
        return SystemScoringOutputCtrl;
    }());
    var SystemScoringOutputDirective = (function () {
        function SystemScoringOutputDirective() {
            this.template = "\n        <div class=\"scoring-output-container\">\n        <h3>Wynik : {{process.ScoringOutput}}</h3>\n        <h4>Sprawdzone regu\u0142y</h4>\n        <table class=\"table table-bordered table-condensed\">\n        <tr ng-repeat=\"rule in rules track by $index\">\n        <td class=\"text-left\">{{rule.klucz}}</td>\n        <td>{{rule.value}}</td>\n        </tr>\n        </table>\n        </div>";
            this.controller = SystemScoringOutputCtrl;
            this.scope = {
                process: "=",
            };
        }
        ;
        SystemScoringOutputDirective.Factory = function () {
            var d = function () { return new SystemScoringOutputDirective(); };
            d['$inject'] = [];
            return d;
        };
        return SystemScoringOutputDirective;
    }());
    systemAdmin.SystemScoringOutputDirective = SystemScoringOutputDirective;
    // dyrektywa z linkiem do przełączenia ekrany na formatkę zmiany hasła
    var ResetPasswordLinkDirective = (function () {
        function ResetPasswordLinkDirective() {
            this.template = "\n        <a ng-click=\"changeViewToResetPasswordForm()\">resetuj has\u0142o</a>\n        ";
        }
        ;
        ResetPasswordLinkDirective.Factory = function () {
            var d = function () { return new ResetPasswordLinkDirective(); };
            d['$inject'] = [];
            return d;
        };
        return ResetPasswordLinkDirective;
    }());
    systemAdmin.ResetPasswordLinkDirective = ResetPasswordLinkDirective;
    // nieużywana dyrektywa
    var ChangePasswordExternalLinkDirective = (function () {
        function ChangePasswordExternalLinkDirective() {
            this.template = "\n        <a href=\"https://leaselink.pl/kontakt\">popro\u015B o nowe has\u0142o</a>\n        <script>\n            window.llContactFormJS = { public_token: \"F2AABD31F4951\", cf_button_text: \"Wy\u015Blij\", cf_button_close: \"Zamknij\", cf_div_background: \"#fff\", cf_on_click: \"#show-ll-form\" };\n        </script>\n        ";
            this.link = function ($scope, $el) {
                var script = document.createElement('script');
                script.src = 'https://leaselink.pl/repository/partner_js_form.js';
                $el.append(angular.element(script));
            };
        }
        ;
        ChangePasswordExternalLinkDirective.Factory = function () {
            var d = function () { return new ChangePasswordExternalLinkDirective(); };
            d['$inject'] = [];
            return d;
        };
        return ChangePasswordExternalLinkDirective;
    }());
    systemAdmin.ChangePasswordExternalLinkDirective = ChangePasswordExternalLinkDirective;
    var SignUpExternalLinkDirective = (function () {
        function SignUpExternalLinkDirective() {
            this.template = "\n        <a href=\"https://leaselink.pl/kontakt\">zosta\u0144 naszym partnerem</a>\n        <script>\n            window.llContactFormJS = { public_token: \"F2AABD31F4951\", cf_button_text: \"Wy\u015Blij\", cf_button_close: \"Zamknij\", cf_div_background: \"#fff\", cf_on_click: \"#show-ll-form\" };\n        </script>\n        ";
            this.link = function ($scope, $el) {
                var script = document.createElement('script');
                script.src = 'https://leaselink.pl/repository/partner_js_form2.js';
                $el.append(angular.element(script));
            };
        }
        ;
        SignUpExternalLinkDirective.Factory = function () {
            var d = function () { return new SignUpExternalLinkDirective(); };
            d['$inject'] = [];
            return d;
        };
        return SignUpExternalLinkDirective;
    }());
    systemAdmin.SignUpExternalLinkDirective = SignUpExternalLinkDirective;
})(systemAdmin || (systemAdmin = {}));
// rejestracja
angular.module('ll.system.admin', ['ngSanitize'])
    .directive('llSystemPanel', systemAdmin.SystemPanelDirective.Factory())
    .directive('llProcessType', systemAdmin.ProcessTypeNameDir.Factory())
    .directive('llSystemFraud', systemAdmin.SystemFraudDirective.Factory())
    .directive('llProcessStatusChangesList', systemAdmin.SystemPanelProcessStatusChangeListDirective.Factory())
    .directive('llProcessPartnerChangesList', systemAdmin.SystemPanelProcessPartnerChangeListDirective.Factory())
    .controller('SystemPanelReportCtrl', systemAdmin.SystemPanelReportCtrl)
    .service('SystemPanelAdminHelperSrv', systemAdmin.SystemPanelAdminHelperSrv)
    .service('SystemFraudSrv', systemAdmin.SystemFraudSrv)
    .directive('llUserAudit', systemAdmin.SystemPanelUserAuditDirective.Factory())
    .service('SystemPanelUserAuditSrv', systemAdmin.SystemPanelUserAuditSrv)
    .directive('llSystemOfferNotes', systemAdmin.SystemOfferNoteDirective.Factory())
    .service('SystemOfferNoteSrv', systemAdmin.SystemOfferNoteSrv)
    .directive('llOfferPaymentConfirmation', systemAdmin.SystemPanelOfferPaymentConfirmationDirective.Factory())
    .service('SystemPanelOfferPaymentConfirmationSrv', systemAdmin.SystemPanelOfferPaymentConfirmationSrv)
    .directive('llClientCommunicationHistory', systemAdmin.SystemPanelPanelClientCommunicationHistoryDirective.Factory())
    .service('SystemPanelClientCommunicationHistorySrv', systemAdmin.SystemPanelClientCommunicationHistorySrv)
    .directive('llSystemLogin', systemAdmin.SystemLoginPanelDirective.Factory())
    .directive('llSystemLoginAuth', systemAdmin.SystemLoginAuthPanelDirective.Factory())
    .directive('llSystemLoginChangePassword', systemAdmin.SystemLoginChangePasswordPanelDirective.Factory())
    .directive('llSystemLoginResetPassword', systemAdmin.SystemLoginResetPasswordPanelDirective.Factory())
    .directive('llSignUpExternalLink', systemAdmin.SignUpExternalLinkDirective.Factory())
    .directive('llChangePasswordExternalLink', systemAdmin.ChangePasswordExternalLinkDirective.Factory())
    .directive('llResetPasswordLink', systemAdmin.ResetPasswordLinkDirective.Factory())
    .directive('llScoringOutput', systemAdmin.SystemScoringOutputDirective.Factory())
    .service('SystemScoringOutputSrv', systemAdmin.SystemScoringOutputSrv);
// zarzadzanie kategoriami / produktami 
var systemCategoryProducts;
(function (systemCategoryProducts) {
    // serwis produktow
    var ProductSrv = (function () {
        function ProductSrv($http) {
            this.$http = $http;
        }
        ProductSrv.$inject = ['$http'];
        return ProductSrv;
    }());
    systemCategoryProducts.ProductSrv = ProductSrv;
    var ProductsCtrl = (function () {
        function ProductsCtrl($scope, $http, $modal, toaster, filterFilter, $rootScope) {
            // opracowanie guida partnera
            $scope.currentPartnerGuid = ($scope.currentPartner ? $scope.currentPartner.Key : "");
            $scope.filteredList = [];
            $scope.search = {
                ProductName: ""
            };
            $scope.ProductModels = [];
            // filtr
            $scope.filterRequest = function (item) {
                if ($scope.search.ProductName) {
                    var _v0 = ($scope.search.ProductName || "").toLowerCase();
                    var _v1 = (item.ProductName + "" || "").toLowerCase();
                    var _v2 = (item.ProductId + "" || "").toLowerCase();
                    var _v3 = (item.ProductCode + "" || "").toLowerCase();
                    var _v4 = (item.ProductCategory + "" || "").toLowerCase();
                    if (_v1.indexOf(_v0) == -1
                        && _v2.indexOf(_v0) == -1
                        && _v3.indexOf(_v0) == -1
                        && _v4.indexOf(_v0) == -1)
                        return false;
                }
                return true;
            };
            // obserwowanie filtra i glownego zbioru danych
            $scope.$watch('search', function () {
                $scope.filteredList = filterFilter($scope.ProductModels, $scope.filterRequest);
            }, true);
            $scope.$watch('ProductModels', function () {
                $scope.filteredList = filterFilter($scope.ProductModels, $scope.filterRequest);
            }, true);
            // pobieranie danych
            $scope.Refresh = function () {
                $http.get('/api/Product?Partner_Guid=' + $scope.currentPartnerGuid).then(function (d) {
                    $scope.ProductModels = d.data.Result;
                }, function (e) {
                    toaster.pop('error', 'Pobieranie danych nie powiodło się');
                });
            };
            // usuanie produktu
            $scope.DeleteProduct = function (id, productPartner) {
                if (confirm("Czy na pewno chcesz usunąć produkt?")) {
                    $http.delete('/api/Product/' + '?id=' + id.toString() + '&productPartner=' + productPartner.toString()).then(function (d) {
                        toaster.pop('success', 'Operacja powiodła się');
                        $scope.Refresh();
                    }, function (e) {
                        toaster.pop('error', 'Operacja nie powiodła się');
                    });
                }
                ;
            };
            $scope.AddProduct = function () {
                $scope.dataForNewProduct = {
                    ProductId: "",
                    ProductName: "",
                    ProductCode: "",
                    ProductCategory: "",
                    ProductAmortizationRate: 0.0,
                    Partner: $scope.currentPartnerGuid
                };
                var modalInstance = $modal.open({
                    animation: true,
                    templateUrl: '/WWW/partials/modules/category.products/addProductModal.html',
                    controller: 'AddProductModalCtrl',
                    scope: $scope,
                    resolve: {
                        dataForNewProduct: function () {
                            return $scope.dataForNewProduct;
                        }
                    }
                });
                modalInstance.result.then(function (dataForNewProduct) {
                    $http.post('/api/Product/', dataForNewProduct).then(function (d) {
                        $scope.Refresh();
                        toaster.pop('success', 'Pomyślnie dodano nowy produkt');
                    }, function (e) {
                        toaster.pop('error', 'Błąd podczas dodawania nowego produktu');
                    });
                }, function (e) { });
            };
            $scope.EditProduct = function (id) {
                $scope.dataForEditProduct = {
                    ProductId: "",
                    ProductName: "",
                    ProductCode: "",
                    ProductCategory: "",
                    ProductAmortizationRate: 0.0
                };
                $http.get('/api/Product/' + id).then(function (d) {
                    $scope.dataForEditProduct = d.data.Result;
                    var modalInstance = $modal.open({
                        animation: true,
                        templateUrl: '/WWW/partials/modules/category.products/editProductModal.html',
                        controller: 'EditProductModalCtrl',
                        scope: $scope,
                        resolve: {
                            dataForEditProduct: function () {
                                return $scope.dataForEditProduct;
                            }
                        }
                    });
                    modalInstance.result.then(function (dataForEditProduct) {
                        $http.put('/api/Product/' + dataForEditProduct.Guid, dataForEditProduct).then(function (f) {
                            $scope.Refresh();
                            toaster.pop('success', 'Pomyślnie zaktualizowano dane produktu');
                        }, function (g) {
                            toaster.pop('error', 'Błąd podczas aktualizacji danych produktu');
                        });
                    }, function (h) { });
                }, function (i) { });
            };
            $scope.setAsDefault = function (productId, partnerId) {
                $http.put('/api/Product/' + '?id=' + productId + '&productPartner=' + partnerId).then(function (d) {
                    $scope.Refresh();
                }, function (e) {
                    toaster.pop('error', 'Pobieranie danych nie powiodło się');
                });
            };
            // pobranie danych na wejsciu
            $scope.Refresh();
        }
        ;
        ProductsCtrl.$inject = ['$scope', '$http', '$modal', 'toaster', 'filterFilter', '$rootScope'];
        return ProductsCtrl;
    }());
    systemCategoryProducts.ProductsCtrl = ProductsCtrl;
    var AddProductModalCtrl = (function () {
        function AddProductModalCtrl($scope, $modalInstance, dataForNewProduct) {
            $scope.dataForNewProduct = dataForNewProduct;
            $scope.ok = function () {
                $modalInstance.close($scope.dataForNewProduct);
            };
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
        }
        ;
        AddProductModalCtrl.$inject = ['$scope', '$modalInstance', 'dataForNewProduct'];
        return AddProductModalCtrl;
    }());
    systemCategoryProducts.AddProductModalCtrl = AddProductModalCtrl;
    var EditProductModalCtrl = (function () {
        function EditProductModalCtrl($scope, $modalInstance, dataForEditProduct) {
            $scope.dataForEditProduct = dataForEditProduct;
            $scope.ok = function () {
                $modalInstance.close($scope.dataForEditProduct);
            };
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
        }
        EditProductModalCtrl.$inject = ['$scope', '$modalInstance', 'dataForEditProduct'];
        return EditProductModalCtrl;
    }());
    systemCategoryProducts.EditProductModalCtrl = EditProductModalCtrl;
})(systemCategoryProducts || (systemCategoryProducts = {}));
// nowy modlu claego wniosku
var systemProcess;
(function (systemProcess) {
    var AddressFormCtrl = (function () {
        function AddressFormCtrl($scope) {
            // lista prefixow
            $scope.streetPrefixes = [
                'AL.',
                'BULW.',
                'DROGA',
                'INNE',
                'OGRÓD',
                'OS.',
                'PARK',
                'PL.',
                'RONDO',
                'RYNEK',
                'SKWER',
                'SZOSA',
                'UL.',
                'WYB.',
                'WYSPA'
            ];
        }
        AddressFormCtrl.$inject = ['$scope'];
        return AddressFormCtrl;
    }());
    var AddressFormDirective = (function () {
        function AddressFormDirective() {
            this.controller = AddressFormCtrl;
            this.templateUrl = "/WWW/partials/addressForm.html";
            this.restrict = "AE";
            this.scope = {
                address: "=",
                isRequired: "=",
                hideSpecificPlace: "=",
                isFormValidated: "="
            };
        }
        AddressFormDirective.Factory = function () {
            var d = function () { return new AddressFormDirective(); };
            d['$inject'] = [];
            return d;
        };
        return AddressFormDirective;
    }());
    systemProcess.AddressFormDirective = AddressFormDirective;
    var PersonFormCtrl = (function () {
        function PersonFormCtrl($scope) {
        }
        PersonFormCtrl.$inject = ['$scope'];
        return PersonFormCtrl;
    }());
    var PersonFormDirective = (function () {
        function PersonFormDirective() {
            this.controller = AddressFormCtrl;
            this.templateUrl = "/WWW/partials/personForm.html";
            this.restrict = "AE";
            this.scope = {
                person: "=",
                isRequired: "=",
                isFormValidated: "="
            };
        }
        PersonFormDirective.Factory = function () {
            var d = function () { return new PersonFormDirective(); };
            d['$inject'] = [];
            return d;
        };
        return PersonFormDirective;
    }());
    systemProcess.PersonFormDirective = PersonFormDirective;
})(systemProcess || (systemProcess = {}));
angular.module("ll.system.process", ['ngSanitize'])
    .directive("llAddressForm", systemProcess.AddressFormDirective.Factory())
    .directive("llPersonForm", systemProcess.PersonFormDirective.Factory());
/*
zarządzanie partnerai
*/
var system;
(function (system) {
    /* partnerzy */
    var PartnersCtrl = (function () {
        function PartnersCtrl($scope, $http, $modal, toaster, FileUploader, filterFilter) {
            $scope.PartnerFunc = "Default";
            $scope.PartnersModels = [];
            $scope.filteredList = [];
            $scope.search = {
                PartnerName: ""
            };
            $scope.config = {
                itemsPerPage: 10,
                maxPages: 10,
                fillLastPage: 'yes'
            };
            // filtr
            $scope.filterRequest = function (item) {
                // jak wypelnione to szukamy po nazwie
                if ($scope.search.PartnerName && item.Name && item.Name.toLowerCase().indexOf($scope.search.PartnerName.toLowerCase()) === -1)
                    return false;
                return true;
            };
            // obserwowanie filtra i glownego zbioru danych
            $scope.$watch('search', function () {
                $scope.filteredList = filterFilter($scope.PartnersModels, $scope.filterRequest);
            }, true);
            $scope.$watch('PartnersModels', function () {
                $scope.filteredList = filterFilter($scope.PartnersModels, $scope.filterRequest);
            }, true);
            $scope.Refresh = function () {
                $http.get('/api/Partner').then(function (d) {
                    $scope.logoTimeStamp = new Date().getTime();
                    $scope.PartnersModels = d.data.Result;
                }, function (e) {
                    toaster.pop('error', 'Pobieranie danych nie powiodło się');
                });
            };
            $scope.Refresh();
            /* //zmienione na inny kontroler
                        $scope.EditPartner = function (id) {
                            var url = '/File/Upload';
            
                            $scope.uploader = new FileUploader({
                                url: url,
                                method: 'PUT',
                                queueLimit: 1
                            });
                            $scope.uploader.onErrorItem = function (fileItem, response, status, headers) {
                                toaster.pop('error', 'Błąd podczas zapisywania pliku');
                            };
                            $scope.uploader.onSuccessItem = function (fileItem, response, status, headers) {
                                fileItem.complete = true;
                                toaster.pop('success', 'Plik zapisano poprawnie');
                                $scope.Refresh();
                            };
                            $scope.uploader.onCompleteItem = function (fileItem, response, status, headers) {
                                fileItem.complete = true;
                                toaster.pop('info', 'Przesył pliku zakończony poprawnie');
                            };
                            $scope.uploader.onBeforeUploadItem = function (fileItem) {
                                fileItem.formData = $scope.uploader.formData;
                            };
            
                            $scope.dataForEditPartner = {
                                Guid: "",
                                Name: "",
                                PartnerUrl: ""
                            };
            
                            $http.get('/api/Partner/' + id).then(
                                function (d) {
                                    $scope.dataForEditPartner = d.data.Result;
            
                                    var modalInstance = $modal.open({
                                        animation: true,
                                        templateUrl: '/WWW/partials/modules/partners/form.html',
                                        controller: 'EditPartnerModalCtrl',
                                        resolve: {
                                            dataForEditPartner: function () {
                                                return $scope.dataForEditPartner;
                                            },
                                            uploader: function () {
                                                return $scope.uploader;
                                            }
                                        }
                                    });
            
                                    modalInstance.result.then(
                                        function (dataForEditPartner) {
                                            $http.put('/api/Partner/' + dataForEditPartner.Guid, dataForEditPartner).then(
                                                function (f) {
                                                    $scope.uploader.formData.push({ type: 'PARTNER' });
                                                    $scope.uploader.formData.push({ oID: f.data.Result.Guid });
                                                    if ($scope.uploader.queue.length == 0) $scope.Refresh();
                                                    $scope.uploader.uploadAll();
                                                    toaster.pop('success', 'Pomyślnie zaktualizowano dane partnera');
                                                    $scope.Refresh();
                                                },
                                                function (g) {
                                                    toaster.pop('error', 'Błąd podczas aktualizacji danych partnera');
                                                });
                                        },
                                        function (h) { }
                                    );
                                },
                                function (i) { }
                            );
                        };
            */
            $scope.showPartnerData = function (item) {
                $scope.currentPartner = item;
                $scope.PartnerFunc = "EditPartner";
            };
            $scope.addNewPartner = function () {
                $scope.currentPartner = {};
                $scope.PartnerFunc = "EditPartner";
            };
            // powrót do widoku partnerów
            $scope.backToPartners = function () {
                $scope.PartnerFunc = "Default";
                $scope.Refresh();
            };
            $scope.DeletePartner = function (id, partnerName) {
                if (confirm("Czy na pewno chcesz usunąć partnera?")) {
                    $http.delete('/api/Partner' + '?id=' + id.toString() + '&partnerName=' + partnerName.toString()).then(function (d) {
                        toaster.pop('success', 'Operacja powiodła się');
                        $scope.Refresh();
                    }, function (e) {
                        toaster.pop('error', 'Operacja nie powiodła się');
                    });
                }
            };
            // aktualizacjia bazy produktowej
            $scope.UploadPartnerProducts = function (Partner_Guid) {
                var url = '/File/Upload';
                $scope.uploader = new FileUploader({
                    url: url,
                    method: 'PUT',
                    queueLimit: 1
                });
                $scope.uploader.onErrorItem = function (fileItem, response, status, headers) {
                    toaster.pop('error', 'Błąd podczas zapisywania pliku');
                };
                $scope.uploader.onSuccessItem = function (fileItem, response, status, headers) {
                    fileItem.complete = true;
                    toaster.pop('success', 'Plik zapisano poprawnie');
                };
                $scope.uploader.onCompleteItem = function (fileItem, response, status, headers) {
                    fileItem.complete = true;
                    toaster.pop('info', 'Przesył pliku zakończony poprawnie');
                };
                $scope.uploader.onBeforeUploadItem = function (fileItem) {
                    fileItem.formData = $scope.uploader.formData;
                };
                $scope.partnerData = {
                    Partner_Guid: Partner_Guid,
                };
                var modalInstance = $modal.open({
                    animation: true,
                    templateUrl: '/WWW/partials/modules/partners/product.upload.html',
                    controller: 'PartnerProductUploadModalCtrl',
                    resolve: {
                        uploader: function () {
                            return $scope.uploader;
                        },
                        partnerData: function () {
                            return $scope.partnerData;
                        }
                    }
                });
                modalInstance.result.then(function (partnerData) {
                    $scope.uploader.formData.push({ type: 'PARTNER_PRODUCT' });
                    $scope.uploader.formData.push({ oID: $scope.partnerData.Partner_Guid });
                    if ($scope.uploader.queue.length == 0)
                        $scope.Refresh();
                    $scope.uploader.onCompleteAll = function () {
                        toaster.pop('success', 'Pomyślnie zaktualizowano dane produktowe partnera');
                    };
                    $scope.uploader.uploadAll();
                }, function (h) { });
            };
        }
        PartnersCtrl.$inject = ['$scope', '$http', '$modal', 'toaster', 'FileUploader', 'filterFilter'];
        return PartnersCtrl;
    }());
    system.PartnersCtrl = PartnersCtrl;
    ;
    /* edycja partnera */
    var PartnerCtrl = (function () {
        function PartnerCtrl($scope, $http, $modal, FileUploader, toaster, filterFilter) {
            $scope.uploader = new FileUploader();
            $scope.ContactPersonModels = [];
            $scope.ContactPeopleList = [];
            $scope.BankAccountModels = [];
            $scope.BankAccountsList = [];
            $scope.PartnerTypes = [
                { key: 1, value: "Sklep" },
                { key: 2, value: "Pośrednik" }
            ];
            var url = '/File/Upload';
            $scope.uploader = new FileUploader({
                url: url,
                method: 'PUT',
                queueLimit: 1
            });
            $scope.uploader.onErrorItem = function (fileItem, response, status, headers) {
                toaster.pop('error', 'Błąd podczas zapisywania pliku');
            };
            $scope.uploader.onSuccessItem = function (fileItem, response, status, headers) {
                fileItem.complete = true;
                toaster.pop('success', 'Plik zapisano poprawnie');
            };
            $scope.uploader.onCompleteItem = function (fileItem, response, status, headers) {
                fileItem.complete = true;
                toaster.pop('info', 'Przesył pliku zakończony poprawnie');
            };
            $scope.uploader.onBeforeUploadItem = function (fileItem) {
                fileItem.formData = $scope.uploader.formData;
            };
            $scope.saveEditedPartner = function () {
                if ($scope.currentPartner.Guid) {
                    $http.put('/api/Partner/' + $scope.currentPartner.Guid, $scope.currentPartner).then(function (d) {
                        $scope.uploader.formData.push({ type: 'PARTNER' });
                        $scope.uploader.formData.push({ oID: d.data.Result.Guid });
                        if ($scope.uploader.queue.length > 0)
                            $scope.uploader.uploadAll();
                        $scope.currentPartner = d.data.Result;
                        toaster.pop('success', "Partner", "Edycja partnera przebiegła poprawnie");
                        if ($scope.currentPartner.CaptchaImage) {
                            $scope.CaptchaData = {
                                CaptchaImage: $scope.currentPartner.CaptchaImage,
                            };
                            var modalInstance = $modal.open({
                                animation: true,
                                templateUrl: '/WWW/partials/modules/partners/CaptchaNeededModal.html',
                                controller: 'CaptchaNeededModalCtrl',
                                resolve: {
                                    CaptchaData: function () {
                                        return $scope.CaptchaData;
                                    }
                                }
                            });
                            modalInstance.result.then(function (CaptchaData) {
                                $http.post("/offer/SetRegonCaptcha", { token: CaptchaData }).then(function (d) {
                                    if (d.data.Status) {
                                        $scope.currentPartner.ShouldDownloadRegistryData = true;
                                        $http.put('/api/Partner/' + $scope.currentPartner.Guid, $scope.currentPartner).then(function (d) {
                                            $scope.currentPartner = d.data.Result;
                                            toaster.pop('success', "Partner", "Edycja partnera przebiegła poprawnie");
                                            $scope.currentPartner.ShouldDownloadRegistryData = false;
                                        }, function (e) {
                                            console.error(e);
                                            toaster.pop('error', "Partner", "Błąd przy edycji partnera");
                                        });
                                    }
                                    //else
                                }, function (e) {
                                    toaster.pop('error', "Pobieranie partnera", "Wystąpił błąd podczas przysłania kodu captcha.");
                                });
                                toaster.pop('success', 'Pomyślnie zaktualizowano dane produktowe partnera');
                            }, function (h) { });
                        }
                    }, function (e) {
                        console.error(e);
                        toaster.pop('error', "Partner", "Błąd przy edycji partnera");
                    });
                }
                else {
                    $http.post('/api/Partner/', $scope.currentPartner).then(function (d) {
                        $scope.uploader.formData.push({ type: 'PARTNER' });
                        $scope.uploader.formData.push({ oID: d.data.Result.Guid });
                        if ($scope.uploader.queue.length > 0)
                            $scope.uploader.uploadAll();
                        $scope.currentPartner = d.data.Result;
                        toaster.pop('success', "Partner", "Dodanie partnera przebiegło poprawnie");
                        if ($scope.currentPartner.CaptchaImage) {
                            $scope.CaptchaData = {
                                CaptchaImage: $scope.currentPartner.CaptchaImage,
                            };
                            var modalInstance = $modal.open({
                                animation: true,
                                templateUrl: '/WWW/partials/modules/partners/CaptchaNeededModal.html',
                                controller: 'CaptchaNeededModalCtrl',
                                resolve: {
                                    CaptchaData: function () {
                                        return $scope.CaptchaData;
                                    }
                                }
                            });
                            modalInstance.result.then(function (CaptchaData) {
                                $http.post("/offer/SetRegonCaptcha", { token: CaptchaData }).then(function (d) {
                                    if (d.data.Status) {
                                        $scope.currentPartner.ShouldDownloadRegistryData = true;
                                        $http.put('/api/Partner/' + $scope.currentPartner.Guid, $scope.currentPartner).then(function (d) {
                                            $scope.currentPartner = d.data.Result;
                                            toaster.pop('success', "Partner", "Edycja partnera przebiegła poprawnie");
                                            $scope.currentPartner.ShouldDownloadRegistryData = false;
                                        }, function (e) {
                                            console.error(e);
                                            toaster.pop('error', "Partner", "Błąd przy edycji partnera");
                                        });
                                    }
                                    //else
                                }, function (e) {
                                    toaster.pop('error', "Pobieranie partnera", "Wystąpił błąd podczas przysłania kodu captcha.");
                                });
                                toaster.pop('success', 'Pomyślnie zaktualizowano dane produktowe partnera');
                            }, function (h) { });
                        }
                    }, function (e) {
                        console.error(e);
                        toaster.pop('error', "Partner", "Błąd przy dodaniu partnera");
                    });
                }
            };
            $scope.downloadRegistryDataAgain = function () {
                $scope.currentPartner.ShouldDownloadRegistryData = true;
                $scope.saveEditedPartner();
            };
            $scope.search = {
                FirstName: "",
                LastName: "",
                Email: ""
            };
            $scope.searchBankAccount = {
                Name: ""
            };
            // filtr osoby kontaktowe
            $scope.filterRequest = function (item) {
                // jak wypelnione to szukamy po nazwie
                //if ($scope.search.LastName && item.LastName && item.LastName.toLowerCase().indexOf($scope.search.LastName.toLowerCase()) === -1) return false;
                if ($scope.search.FirstName) {
                    var _v0 = ($scope.search.FirstName || "").toLowerCase();
                    var _v1 = (item.FirstName + "" || "").toLowerCase();
                    if (_v1.indexOf(_v0) == -1)
                        return false;
                }
                if ($scope.search.LastName) {
                    var _v0 = ($scope.search.LastName || "").toLowerCase();
                    var _v1 = (item.LastName + "" || "").toLowerCase();
                    if (_v1.indexOf(_v0) == -1)
                        return false;
                }
                if ($scope.search.Email) {
                    var _v0 = ($scope.search.Email || "").toLowerCase();
                    var _v1 = (item.Email + "" || "").toLowerCase();
                    if (_v1.indexOf(_v0) == -1)
                        return false;
                }
                return true;
            };
            // filtr rachunki bankowe
            $scope.bankAccountFilterRequest = function (item) {
                // jak wypelnione to szukamy po nazwie
                //if ($scope.search.LastName && item.LastName && item.LastName.toLowerCase().indexOf($scope.search.LastName.toLowerCase()) === -1) return false;
                if ($scope.searchBankAccount.Name) {
                    var _v0 = ($scope.searchBankAccount.Name || "").toLowerCase();
                    var _v1 = (item.Name + "" || "").toLowerCase();
                    if (_v1.indexOf(_v0) == -1)
                        return false;
                }
                return true;
            };
            // obserwowanie filtra i glownego zbioru danych (osoby kontaktowe)
            $scope.$watch('search', function () {
                $scope.ContactPeopleList = filterFilter($scope.ContactPersonModels, $scope.filterRequest);
            }, true);
            $scope.$watch('ContactPersonModels', function () {
                $scope.ContactPeopleList = filterFilter($scope.ContactPersonModels, $scope.filterRequest);
            }, true);
            // obserwowanie filtra i glownego zbioru danych (rachunki bankowe)
            $scope.$watch('searchBankAccount', function () {
                $scope.BankAccountsList = filterFilter($scope.BankAccountModels, $scope.bankAccountFilterRequest);
            }, true);
            $scope.$watch('BankAccountModels', function () {
                $scope.BankAccountsList = filterFilter($scope.BankAccountModels, $scope.bankAccountFilterRequest);
            }, true);
            $scope.RefreshContactPeople = function () {
                $http.get('/api/ContactPerson' + '?partitionKey=' + $scope.currentPartner.Guid).then(function (d) {
                    $scope.ContactPersonModels = d.data.Result;
                }, function (e) {
                    toaster.pop('error', 'Pobieranie danych nie powiodło się');
                });
            };
            $scope.RefreshContactPeople();
            $scope.RefreshBankAccounts = function () {
                $http.get('/api/BankAccount' + '?partitionKey=' + $scope.currentPartner.Guid).then(function (d) {
                    $scope.BankAccountModels = d.data.Result;
                }, function (e) {
                    toaster.pop('error', 'Pobieranie danych nie powiodło się');
                });
            };
            $scope.RefreshBankAccounts();
            // operacje na osobach kontaktowych
            $scope.AddContactPerson = function () {
                $scope.dataForNewContactPerson = {
                    PartnerID: $scope.currentPartner.Guid,
                    FirstName: "",
                    LastName: "",
                    Email: "",
                    PhoneNumber: ""
                };
                var modalInstance = $modal.open({
                    animation: true,
                    templateUrl: '/WWW/partials/addContactPersonModal.html',
                    controller: 'AddContactPersonModalCtrl',
                    scope: $scope,
                    resolve: {
                        dataForNewContactPerson: function () {
                            return $scope.dataForNewContactPerson;
                        }
                    }
                });
                modalInstance.result.then(function (dataForNewContactPerson) {
                    $http.post('/api/ContactPerson/', dataForNewContactPerson).then(function (d) {
                        $scope.RefreshContactPeople();
                        toaster.pop('success', 'Pomyślnie dodano nową osobę kontaktową');
                    }, function (e) {
                        toaster.pop('error', 'Błąd podczas dodawania osoby kontaktowej');
                    });
                }, function (e) { });
            };
            $scope.EditContactPerson = function (contactPerson) {
                $scope.dataForEditContactPerson = contactPerson;
                var modalInstance = $modal.open({
                    animation: true,
                    templateUrl: '/WWW/partials/editContactPersonModal.html',
                    controller: 'EditContactPersonCtrl',
                    scope: $scope,
                    resolve: {
                        dataForEditContactPerson: function () {
                            return $scope.dataForEditContactPerson;
                        }
                    }
                });
                modalInstance.result.then(function (dataForEditContactPerson) {
                    $http.put('/api/ContactPerson/' + dataForEditContactPerson.Guid, dataForEditContactPerson).then(function (f) {
                        $scope.RefreshContactPeople();
                        toaster.pop('success', 'Pomyślnie zaktualizowano dane osoby kontaktowej');
                    }, function (g) {
                        toaster.pop('error', 'Błąd podczas aktualizacji danych osoby kontaktowej');
                    });
                }, function (h) { });
            };
            $scope.DeleteContactPerson = function (id) {
                if (confirm("Czy na pewno chcesz usunąć osobę kontaktową?")) {
                    $http.delete('/api/ContactPerson' + '?id=' + id.toString()).then(function (d) {
                        toaster.pop('success', 'Operacja powiodła się');
                        $scope.RefreshContactPeople();
                    }, function (e) {
                        toaster.pop('error', 'Operacja nie powiodła się');
                    });
                }
            };
            // operacje na rachunkach bankowych
            $scope.AddBankAccount = function () {
                $scope.dataForNewBankAccount = {
                    PartnerID: $scope.currentPartner.Guid,
                    Name: "",
                    IBAN: "",
                    BankAccountStatus: "Aktywny"
                };
                var modalInstance = $modal.open({
                    animation: true,
                    templateUrl: '/WWW/partials/addBankAccountModal.html',
                    controller: 'AddBankAccountModalCtrl',
                    scope: $scope,
                    resolve: {
                        dataForNewBankAccount: function () {
                            return $scope.dataForNewBankAccount;
                        }
                    }
                });
                modalInstance.result.then(function (dataForNewBankAccount) {
                    $http.post('/api/BankAccount/', dataForNewBankAccount).then(function (d) {
                        $scope.RefreshBankAccounts();
                        toaster.pop('success', 'Pomyślnie dodano nowy rachunek bankowy');
                    }, function (e) {
                        toaster.pop('error', 'Błąd podczas dodawania rachunku bankowego');
                    });
                }, function (e) { });
            };
            $scope.EditBankAccount = function (bankAccount) {
                $scope.dataForEditBankAccount = bankAccount;
                var modalInstance = $modal.open({
                    animation: true,
                    templateUrl: '/WWW/partials/editBankAccountModal.html',
                    controller: 'EditBankAccountModalCtrl',
                    scope: $scope,
                    resolve: {
                        dataForEditBankAccount: function () {
                            return $scope.dataForEditBankAccount;
                        }
                    }
                });
                modalInstance.result.then(function (dataForEditBankAccount) {
                    $http.put('/api/BankAccount/' + dataForEditBankAccount.Guid, dataForEditBankAccount).then(function (f) {
                        $scope.RefreshBankAccounts();
                        toaster.pop('success', 'Pomyślnie zaktualizowano dane rachunku bankowego');
                    }, function (g) {
                        toaster.pop('error', 'Błąd podczas aktualizacji danych rachunku bankowego');
                    });
                }, function (h) { });
            };
            $scope.DeleteBankAccount = function (bankAccount) {
                //$scope.dataForDeleteBankAccount = bankAccount;
                bankAccount.BankAccountStatus = "Historyczny";
                if (confirm("Czy na pewno chcesz usunąć rachunek bankowy?")) {
                    $http.put('/api/BankAccount/' + bankAccount.Guid, bankAccount).then(function (d) {
                        $scope.RefreshBankAccounts();
                        toaster.pop('success', "Rachunek bankowy", "Status rachunku zmieniony na 'Historyczny'");
                    }, function (e) {
                        console.error(e);
                        toaster.pop('error', "Rachunek bankowy", "Błąd przy usuwaniu rachunku bankowego");
                    });
                }
            };
        }
        PartnerCtrl.$inject = ['$scope', '$http', '$modal', 'FileUploader', 'toaster', 'filterFilter'];
        return PartnerCtrl;
    }());
    system.PartnerCtrl = PartnerCtrl;
    /* ladowanie produktow dla prartnerow */
    var PartnerProductUploadModalCtrl = (function () {
        function PartnerProductUploadModalCtrl($scope, $modalInstance, uploader, partnerData) {
            $scope.uploader = uploader;
            $scope.partnerData = partnerData;
            $scope.ok = function () {
                $modalInstance.close($scope.partnerData);
            };
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
        }
        PartnerProductUploadModalCtrl.$inject = ['$scope', '$modalInstance', 'uploader', 'partnerData'];
        return PartnerProductUploadModalCtrl;
    }());
    system.PartnerProductUploadModalCtrl = PartnerProductUploadModalCtrl;
    ;
    /* dodawanie osoby kontaktowej */
    var AddContactPersonModalCtrl = (function () {
        function AddContactPersonModalCtrl($scope, $modalInstance, dataForNewContactPerson) {
            $scope.dataForNewContactPerson = dataForNewContactPerson;
            $scope.ok = function () {
                $modalInstance.close($scope.dataForNewContactPerson);
            };
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
        }
        AddContactPersonModalCtrl.$inject = ['$scope', '$modalInstance', 'dataForNewContactPerson'];
        return AddContactPersonModalCtrl;
    }());
    system.AddContactPersonModalCtrl = AddContactPersonModalCtrl;
    ;
    var EditContactPersonCtrl = (function () {
        function EditContactPersonCtrl($scope, $modalInstance, dataForEditContactPerson) {
            $scope.dataForEditContactPerson = dataForEditContactPerson;
            $scope.ok = function () {
                $modalInstance.close($scope.dataForEditContactPerson);
            };
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
                $scope.RefreshContactPeople();
            };
        }
        EditContactPersonCtrl.$inject = ['$scope', '$modalInstance', 'dataForEditContactPerson'];
        return EditContactPersonCtrl;
    }());
    system.EditContactPersonCtrl = EditContactPersonCtrl;
    ;
    /* dodawanie rachunku bankowego */
    var AddBankAccountModalCtrl = (function () {
        function AddBankAccountModalCtrl($scope, $modalInstance, dataForNewBankAccount) {
            $scope.dataForNewBankAccount = dataForNewBankAccount;
            $scope.ok = function () {
                $modalInstance.close($scope.dataForNewBankAccount);
            };
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
        }
        AddBankAccountModalCtrl.$inject = ['$scope', '$modalInstance', 'dataForNewBankAccount'];
        return AddBankAccountModalCtrl;
    }());
    system.AddBankAccountModalCtrl = AddBankAccountModalCtrl;
    ;
    var EditBankAccountModalCtrl = (function () {
        function EditBankAccountModalCtrl($scope, $modalInstance, dataForEditBankAccount) {
            $scope.dataForEditBankAccount = dataForEditBankAccount;
            $scope.ok = function () {
                $modalInstance.close($scope.dataForEditBankAccount);
            };
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
                $scope.RefreshBankAccounts();
            };
        }
        EditBankAccountModalCtrl.$inject = ['$scope', '$modalInstance', 'dataForEditBankAccount'];
        return EditBankAccountModalCtrl;
    }());
    system.EditBankAccountModalCtrl = EditBankAccountModalCtrl;
    ;
    var CaptchaNeededModalCtrl = (function () {
        function CaptchaNeededModalCtrl($scope, $modalInstance, CaptchaData) {
            $scope.CaptchaData = CaptchaData;
            $scope.ok = function () {
                $modalInstance.close($scope.CaptchaData);
            };
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
        }
        CaptchaNeededModalCtrl.$inject = ['$scope', '$modalInstance', 'CaptchaData'];
        return CaptchaNeededModalCtrl;
    }());
    system.CaptchaNeededModalCtrl = CaptchaNeededModalCtrl;
    ;
    // kontroller produktow partnera
    var PartnerProductCtrl = (function () {
        function PartnerProductCtrl($scope, PartnerProductSrv) {
            // domyslana zakladka
            $scope.currentPartnerProductTab = '';
        }
        PartnerProductCtrl.$inject = ['$scope', 'PartnerProductSrv'];
        return PartnerProductCtrl;
    }());
    system.PartnerProductCtrl = PartnerProductCtrl;
    var PartnerSystemProductsCtrl = (function () {
        function PartnerSystemProductsCtrl($scope, $http, toaster, filterFilter, PartnerProductSrv, $rootScope) {
            // opracowanie guida partnera
            $scope.currentPartnerGuid = ($scope.currentPartner ? $scope.currentPartner.Key : "");
            $scope.filteredList = [];
            $scope.search = {
                ProductName: ""
            };
            $scope.ProductModels = [];
            // filtr
            $scope.filterRequest = function (item) {
                if ($scope.search.ProductName) {
                    var _v0 = ($scope.search.ProductName || "").toLowerCase();
                    var _v1 = (item.Product.ProductName + "" || "").toLowerCase();
                    var _v2 = (item.Product.ProductId + "" || "").toLowerCase();
                    var _v3 = (item.Product.ProductCode + "" || "").toLowerCase();
                    var _v4 = (item.Product.ProductCategory + "" || "").toLowerCase();
                    if (_v1.indexOf(_v0) == -1
                        && _v2.indexOf(_v0) == -1
                        && _v3.indexOf(_v0) == -1
                        && _v4.indexOf(_v0) == -1)
                        return false;
                }
                return true;
            };
            // obserwowanie filtra i glownego zbioru danych
            $scope.$watch('search', function () {
                $scope.filteredList = filterFilter($scope.ProductModels, $scope.filterRequest);
            }, true);
            $scope.$watch('ProductModels', function () {
                $scope.filteredList = filterFilter($scope.ProductModels, $scope.filterRequest);
            }, true);
            // pobieranie danych
            $scope.Refresh = function () {
                PartnerProductSrv.listSystemProducts($scope.currentPartnerGuid).then(function (d) {
                    $scope.ProductModels = d.data.Result;
                }, function (e) {
                    toaster.pop('error', 'Pobieranie danych nie powiodło się');
                });
            };
            $scope.AddProduct = function (Product_Guid) {
                var obj = {
                    Product_Guid: Product_Guid,
                    Partner_Guid: $scope.currentPartnerGuid,
                    Included: true
                };
                PartnerProductSrv.updatePartnerSystemProduct(obj).then(function (d) {
                    $scope.Refresh();
                }, function (e) {
                    toaster.pop('error', 'Zapisywanie danych nie powiodło się');
                });
            };
            $scope.DeleteProduct = function (Product_Guid) {
                var obj = {
                    Product_Guid: Product_Guid,
                    Partner_Guid: $scope.currentPartnerGuid,
                    Included: false
                };
                PartnerProductSrv.updatePartnerSystemProduct(obj).then(function (d) {
                    $scope.Refresh();
                }, function (e) {
                    toaster.pop('error', 'Zapisywanie danych nie powiodło się');
                });
            };
            $scope.setAsDefault = function (productId, partnerId) {
                $http.put('/api/PartnerSystemProduct/' + '?id=' + productId + '&productPartner=' + partnerId).then(function (d) {
                    $scope.Refresh();
                }, function (e) {
                    toaster.pop('error', 'Pobieranie danych nie powiodło się');
                });
            };
            // domyslnie pobranie
            $scope.Refresh();
        }
        PartnerSystemProductsCtrl.$inject = ['$scope', '$http', 'toaster', 'filterFilter', 'PartnerProductSrv', '$rootScope'];
        return PartnerSystemProductsCtrl;
    }());
    system.PartnerSystemProductsCtrl = PartnerSystemProductsCtrl;
    // serwis produktow partnera
    var PartnerProductSrv = (function () {
        function PartnerProductSrv($http) {
            var _this = this;
            this.$http = $http;
            this.listSystemProducts = function (Partner_Guid) {
                return _this.$http.get('/api/PartnerSystemProduct?Partner_Guid=' + Partner_Guid);
            };
            this.updatePartnerSystemProduct = function (obj) {
                return _this.$http.post('/api/PartnerSystemProduct', obj);
            };
        }
        PartnerProductSrv.$inject = ['$http'];
        return PartnerProductSrv;
    }());
    system.PartnerProductSrv = PartnerProductSrv;
})(system || (system = {}));
var system;
(function (system) {
    // produkty
    var LeaselinkProductsMainCtrl = (function () {
        function LeaselinkProductsMainCtrl($rootScope, $scope, $location, $http, toaster, $modal, filterFilter) {
            $scope.ProductFunc = "Parents";
            $scope.ProductsList = [];
            $scope.filteredList = [];
            $scope.config = {
                itemsPerPage: 10,
                maxPages: 10,
                fillLastPage: 'yes'
            };
            $scope.search = {
                Product: ""
            };
            // filtr
            $scope.filterRequest = function (item) {
                if ($scope.search.Product) {
                    var _v0 = ($scope.search.Product || "").toLowerCase();
                    var _v1 = (item.FinancialProductName || "").toLowerCase();
                    // sprawdzanie czy się zawiera
                    if (!~_v1.indexOf(_v0))
                        return false;
                }
                return true;
            };
            // obserwowanie filtra i glownego zbioru danych
            $scope.$watch('search', function () {
                $scope.filteredList = filterFilter($scope.ProductsList, $scope.filterRequest);
            }, true);
            $scope.$watch('ProductsList', function () {
                $scope.filteredList = filterFilter($scope.ProductsList, $scope.filterRequest);
            }, true);
            $scope.Refresh = function () {
                $http.get('/api/LeaselinkProduct').then(function (d) {
                    $scope.ProductsList = d.data.Result;
                }, function (e) {
                    toaster.pop('error', 'Pobieranie danych nie powiodło się');
                });
            };
            $scope.Refresh();
            // pokazanie elementów
            $scope.showItem = function (item) {
                item.EditMode = false;
                item.Validfrom = new Date(item.Validfrom) || null;
                item.Validto = new Date(item.Validto) || null;
                item.Procestill = new Date(item.Procestill) || null;
                var modalInstance = $modal.open({
                    animation: true,
                    templateUrl: '/WWW/partials/modules/products/form.html',
                    controller: 'LeaselinkProductCtrl',
                    resolve: {
                        item: function () {
                            return item;
                        }
                    }
                });
                modalInstance.result.then(function (item) {
                    //$scope.item = item;
                    $scope.Refresh();
                }, function () { });
            };
            $scope.addItem = function () {
                var item = {
                    EditMode: true
                };
                $scope.showItem(item);
            };
            $scope.deleteItem = function (item) {
                if (confirm("Czy na pewno chcesz usunąć pozycję ?")) {
                    $http.delete('/api/LeaselinkProduct/' + item.Guid).then(function (d) {
                        toaster.pop('success', "Produkty", "Dane usunięto poprawnie.");
                        $scope.Refresh();
                    }, function (e) {
                        toaster.pop('error', "Produkty", "Wystąpił bład podczas usuwania danych.");
                    });
                }
            };
            // $scope.ProductFunc = "Parents";
            $scope.showChildren = function (item) {
                $scope.currentParent = item;
                $scope.ProductFunc = "Children";
            };
            // event powrotu do produktów finansowych (button)
            $scope.backToFinancialProducts = function () {
                $scope.ProductFunc = "Parents";
                $rootScope.$broadcast('back-to-financial-products');
            };
            // powrot do produktów finansowych (zakładka)
            $scope.$on('current-productFunc-Parents', function (event, args) {
                $scope.ProductFunc = "Parents";
            });
        }
        LeaselinkProductsMainCtrl.$inject = ['$rootScope', '$scope', '$location', '$http', 'toaster', '$modal', 'filterFilter'];
        return LeaselinkProductsMainCtrl;
    }());
    system.LeaselinkProductsMainCtrl = LeaselinkProductsMainCtrl;
    var LeaselinkProductCtrl = (function () {
        function LeaselinkProductCtrl($rootScope, $scope, $modalInstance, toaster, $http, item) {
            $scope.item = item;
            $scope.editItem = function () {
                // pokazanie danych
                $scope.item.EditMode = true;
            };
            // oddanie danych
            $scope.saveItem = function () {
                if (!item.Guid) {
                    $http.post("/api/LeaselinkProduct", $scope.item).then(function (d) {
                        $scope.item = d.data;
                        $modalInstance.close($scope.item);
                    }, function (e) {
                        console.error(e);
                        toaster.pop('error', "Produkty", "Błąd przy dodawaniu produktu");
                    });
                }
                else {
                    $http.put("/api/LeaselinkProduct/" + item.Guid, $scope.item).then(function (d) {
                        $scope.item = d.data;
                        $modalInstance.close($scope.item);
                    }, function (e) {
                        console.error(e);
                        toaster.pop('error', "Produkty", "Błąd przy dodawaniu produktu");
                    });
                }
            };
            // zamkniecie
            $scope.cancel = function () {
                $scope.item.EditMode = false;
                $modalInstance.dismiss('cancel');
            };
        }
        LeaselinkProductCtrl.$inject = ['$rootScope', '$scope', '$modalInstance', 'toaster', '$http', 'item'];
        return LeaselinkProductCtrl;
    }());
    system.LeaselinkProductCtrl = LeaselinkProductCtrl;
    var LeaselinkChildProductCtrl = (function () {
        function LeaselinkChildProductCtrl($rootScope, $scope, $modalInstance, toaster, $http, item) {
            $scope.item = item;
            $scope.editItem = function () {
                // pokazanie danych
                $scope.item.EditMode = true;
            };
            // oddanie danych
            $scope.saveItem = function () {
                if (!item.Guid) {
                    $http.post("/api/LeaselinkSubProduct", $scope.item).then(function (d) {
                        $scope.item = d.data;
                        $modalInstance.close($scope.item);
                    }, function (e) {
                        console.error(e);
                        toaster.pop('error', "Produkty", "Błąd przy dodawaniu produktu");
                    });
                }
                else {
                    $http.put("/api/LeaselinkSubProduct/" + item.Guid, $scope.item).then(function (d) {
                        $scope.item = d.data;
                        $modalInstance.close($scope.item);
                    }, function (e) {
                        console.error(e);
                        toaster.pop('error', "Produkty", "Błąd przy dodawaniu produktu");
                    });
                }
            };
            // zamkniecie
            $scope.cancel = function () {
                $scope.item.EditMode = false;
                $modalInstance.dismiss('cancel');
            };
        }
        LeaselinkChildProductCtrl.$inject = ['$rootScope', '$scope', '$modalInstance', 'toaster', '$http', 'item'];
        return LeaselinkChildProductCtrl;
    }());
    system.LeaselinkChildProductCtrl = LeaselinkChildProductCtrl;
    var LeaselinkProductChildrenCtrl = (function () {
        function LeaselinkProductChildrenCtrl($rootScope, $scope, $location, $http, toaster, $modal, filterFilter) {
            $scope.ProductChildrenList = [];
            $scope.filteredList = [];
            $scope.config = {
                itemsPerPage: 10,
                maxPages: 10,
                fillLastPage: 'yes'
            };
            $scope.search = {
                Product: ""
            };
            // filtr
            $scope.filterRequest = function (item) {
                if ($scope.search.Product) {
                    var _v0 = ($scope.search.Product || "").toLowerCase();
                    var _v1 = (item.FinancialProductName || "").toLowerCase();
                    // sprawdzanie czy się zawiera
                    if (!~_v1.indexOf(_v0))
                        return false;
                }
                return true;
            };
            // obserwowanie filtra i glownego zbioru danych
            $scope.$watch('search', function () {
                $scope.filteredList = filterFilter($scope.ProductChildrenList, $scope.filterRequest);
            }, true);
            $scope.$watch('ProductChildrenList', function () {
                $scope.filteredList = filterFilter($scope.ProductChildrenList, $scope.filterRequest);
            }, true);
            $scope.Refresh = function () {
                $http.get('/api/LeaselinkSubProduct?partitionKey=' + $scope.currentParent.Guid).then(function (d) {
                    $scope.ProductChildrenList = d.data.Result;
                }, function (e) {
                    toaster.pop('error', 'Pobieranie danych nie powiodło się');
                });
            };
            $scope.Refresh();
            // pokazanie elementów
            $scope.showItem = function (item) {
                item.EditMode = item.EditMode || false;
                var modalInstance = $modal.open({
                    animation: true,
                    templateUrl: '/WWW/partials/modules/products/childrenForm.html',
                    controller: 'LeaselinkChildProductCtrl',
                    resolve: {
                        item: function () {
                            return item;
                        }
                    }
                });
                modalInstance.result.then(function (item) {
                    //$scope.item = item;
                    $scope.Refresh();
                }, function () { });
            };
            $scope.addItem = function () {
                var item = {
                    EditMode: true,
                    ParentGuid: $scope.currentParent.Guid,
                    NetValueMin: $scope.currentParent.NetValueMin,
                    NetValueMax: $scope.currentParent.NetValueMax,
                    GrossValueMin: $scope.currentParent.GrossValueMin,
                    GrossValueMax: $scope.currentParent.GrossValueMax,
                    EntryPaymentMin: $scope.currentParent.EntryPaymentMin,
                    EntryPaymentMax: $scope.currentParent.EntryPaymentMax,
                    AdminPaymentMin: $scope.currentParent.AdminPaymentMin,
                    AdminPaymentMax: $scope.currentParent.AdminPaymentMax,
                    NumberOfRatesMin: $scope.currentParent.NumberOfRatesMin,
                    NumberOfRatesMax: $scope.currentParent.NumberOfRatesMax,
                    ClosingPaymentMin: $scope.currentParent.ClosingPaymentMin,
                    ClosingPaymentMax: $scope.currentParent.ClosingPaymentMax,
                    MarginMin: $scope.currentParent.MarginMin,
                    MarginMax: $scope.currentParent.MarginMax
                };
                $scope.showItem(item);
            };
            $scope.deleteItem = function (item) {
                if (confirm("Czy na pewno chcesz usunąć pozycję ?")) {
                    $http.delete('/api/LeaselinkSubProduct/' + item.Guid).then(function (d) {
                        toaster.pop('success', "Produkty", "Dane usunięto poprawnie.");
                        $scope.Refresh();
                    }, function (e) {
                        toaster.pop('error', "Produkty", "Wystąpił bład podczas usuwania danych.");
                    });
                }
            };
        }
        LeaselinkProductChildrenCtrl.$inject = ['$rootScope', '$scope', '$location', '$http', 'toaster', '$modal', 'filterFilter'];
        return LeaselinkProductChildrenCtrl;
    }());
    system.LeaselinkProductChildrenCtrl = LeaselinkProductChildrenCtrl;
})(system || (system = {}));
/*
moduł zarzadzania użytkownikami
*/
//import "../commons/filters/system_filters";
var system;
(function (system) {
    /* uzytkownicy */
    var UsersCtrl = (function () {
        function UsersCtrl($rootScope, $scope, $location, $http, toaster, $modal, filterFilter, SystemDataHelper) {
            $scope.UsersModels = [];
            $scope.filteredList = [];
            $scope.config = {
                itemsPerPage: 10,
                maxPages: 10,
                fillLastPage: "yes",
            };
            $scope.search = {
                Phrase: "",
                Partner: "",
            };
            // filtr
            $scope.filterRequest = function (item) {
                if ($scope.search.Phrase) {
                    var _v0 = ($scope.search.Phrase || "").toLowerCase();
                    var _v1 = (item.Login + "" || "").toLowerCase();
                    var _v2 = (item.FirstName + "" || "").toLowerCase();
                    var _v3 = (item.LastName + "" || "").toLowerCase();
                    var _v4 = (item.ExternalId + "" || "").toLowerCase();
                    if (_v1.indexOf(_v0) == -1 &&
                        _v2.indexOf(_v0) == -1 &&
                        _v3.indexOf(_v0) == -1 &&
                        _v4.indexOf(_v0) == -1)
                        return false;
                }
                if ($scope.search.Partner) {
                    var _v0 = ($scope.search.Partner || "").toLowerCase();
                    var _v1 = (item.Partner + "" || "").toLowerCase();
                    if (_v1 !== _v0)
                        return false;
                }
                return true;
            };
            // obserwowanie filtra i glownego zbioru danych
            $scope.$watch("search", function () {
                $scope.filteredList = filterFilter($scope.UsersModels, $scope.filterRequest);
            }, true);
            $scope.$watch("UsersModels", function () {
                $scope.filteredList = filterFilter($scope.UsersModels, $scope.filterRequest);
            }, true);
            $scope.PartnerSupervisors = [];
            $scope.Partners = [];
            // pobranie partnerow
            $http.get("/offerbusinessdata/getpartnersbase").then(function (d) {
                $scope.Partners = [];
                $scope.Partners = _.map(d.data, function (i) {
                    return { k: i.Key, v: i.Name, url: i.PartnerUrl };
                });
            }, function (e) {
                console.error(e);
            });
            $scope.Roles = [
                {
                    k: "PARTNER_OPERATOR",
                    v: "Konsultant Partnera",
                },
                {
                    k: "WWW_OPERATOR",
                    v: "Użytkownik internetowy",
                },
            ];
            $scope.refresh = function () {
                $http.get("/api/PartnerUser").then(function (d) {
                    $scope.UsersModels = d.data.Result;
                    $scope.PartnerSupervisors = $scope.UsersModels.map(function (item) {
                        return {
                            Guid: item.Guid,
                            FullName: item.LastName +
                                ", " +
                                item.FirstName +
                                " [" +
                                item.Partner +
                                "]",
                        };
                    });
                }, function (e) {
                    toaster.pop("error", "Użytkownicy", "Pobieranie danych nie powiodło się");
                });
            };
            $scope.refresh();
            // pokazanie elementów
            $scope.showItem = function (item) {
                item.EditMode = false;
                var modalInstance = $modal.open({
                    animation: true,
                    templateUrl: "/WWW/partials/modules/users/form.html",
                    controller: "UserCtrl",
                    resolve: {
                        item: function () {
                            return item;
                        },
                        PartnerSupervisors: function () {
                            return $scope.PartnerSupervisors;
                        },
                        Roles: function () {
                            return $scope.Roles;
                        },
                    },
                });
                modalInstance.result.then(function (item) {
                    //$scope.item = item;
                    $scope.refresh();
                }, function () { });
            };
            // pokazanie szczegolow uzytkownika
            $scope.showUserData = function (item) {
                $http.get("/api/PartnerUser?userId=" + item.Id).then(function (d) {
                    $scope.currentUser = d.data.Result;
                    $scope.currentUser.EditMode = false;
                    $scope.UserFunc = "EditUser";
                }, function (e) {
                    toaster.pop("error", "Użytkownicy", "Wystąpił bład podczas pobierania danych.");
                });
            };
            // zmiana hasła przez admina
            $scope.changePasswordItem = function (item) {
                item.EditMode = false;
                var modalInstance = $modal.open({
                    animation: true,
                    templateUrl: "/WWW/partials/modules/users/partnerUserChangePassword.html",
                    controller: "UserPasswordCtrl",
                    resolve: {
                        item: function () {
                            return item;
                        },
                    },
                });
                modalInstance.result.then(function (item) { }, function () { });
            };
            // dodanie nowego
            $scope.addNewUser = function () {
                $scope.currentUser = {};
                $scope.currentUser.EditMode = true;
                $scope.UserFunc = "EditUser";
            };
            $scope.backToUsers = function () {
                $scope.currentUser.EditMode = false;
                $scope.UserFunc = "Default";
                $scope.refresh();
            };
            $scope.addItem = function () {
                var item = {
                    EditMode: true,
                    Roles: [],
                };
                $scope.showItem(item);
            };
            $scope.deleteItem = function (item) {
                if (confirm("Czy na pewno chcesz usunąć pozycję ?")) {
                    $http.delete("/api/PartnerUser?userId=" + item.Id).then(function (d) {
                        toaster.pop("success", "Użytkownicy", "Dane usunięto poprawnie.");
                        $scope.refresh();
                    }, function (e) {
                        toaster.pop("error", "Użytkownicy", "Wystąpił bład podczas usuwania danych.");
                    });
                }
            };
            $scope.editItem = function () {
                // pokazanie danych
                $scope.currentUser.EditMode = true;
            };
            // oddanie danych
            $scope.saveEditedUser = function () {
                //LL-1671 schowanie loginu, login ma być taki sam jak e-mail
                var model = $scope.currentUser;
                model.Login = model.Email;
                $http.put("/api/PartnerUser", model).then(function (d) {
                    if (d.data.Result == null) {
                        toaster.pop("error", "Użytkownicy", "Użytkownik o podanym loginie już istnieje");
                        $scope.backToUsers();
                    }
                    $scope.currentUser = d.data.Result;
                    $scope.currentUser.EditMode = false;
                    $rootScope.$broadcast("update-statuses-filter");
                    $scope.backToUsers();
                    toaster.pop("success", "Użytkownicy", "Użytkownik dodany/edytowany poprawnie");
                }, function (e) {
                    toaster.pop("error", "Użytkownicy", "Użytkownik o podanym loginie już istnieje");
                });
            };
            $scope.searchStatuses = {
                name: "",
            };
            $scope.AllStatuses = [
                {
                    name: "Anulowany",
                    value: -1,
                },
                {
                    name: "Nowy",
                    value: 0,
                },
                {
                    name: "Wysłano link do klienta",
                    value: 10,
                },
                {
                    name: "Otwarty przez klienta",
                    value: 20,
                },
                {
                    name: "Wybór wniosku do realizacji",
                    value: 21,
                },
                {
                    name: "Uzupełniony przez klienta",
                    value: 30,
                },
                {
                    name: "Opłata weryfikacyjna do zapłaty",
                    value: 32,
                },
                {
                    name: "Zapłacony przez klienta",
                    value: 40,
                },
                {
                    name: "Ponów płatność 1 PLN",
                    value: 41,
                },
                {
                    name: "Odrzucony przez klienta",
                    value: 50,
                },
                {
                    name: "Prośba o uzupełnienie wymaganych dokumentów",
                    value: 55,
                },
                {
                    name: "Wstępna decyzja kredytowa",
                    value: 52,
                },
                {
                    name: "Prośba o uzupełnienie wymaganych dokumentów finansowych (VAT-owiec)",
                    value: 53,
                },
                {
                    name: "Prośba o uzupełnienie wymaganych dokumentów finansowych (nie-VAT-owiec)",
                    value: 54,
                },
                {
                    name: "Do weryfikacji BO / Przekaż do Ryzyka",
                    value: 60,
                },
                {
                    name: "Automat scoringowy - oczekiwanie na odpowiedź",
                    value: 61,
                },
                {
                    name: "Automat scoringowy - odpowiedź gotowa",
                    value: 62,
                },
                {
                    name: "Analiza ryzyka",
                    value: 63,
                },
                {
                    name: "Błąd identyfikacji tożsamości",
                    value: 67,
                },
                {
                    name: "Umowa wstepna przygotowana",
                    value: 70,
                },
                {
                    name: "Konieczność opłaty WOL (uzupełnienie danych)",
                    value: 71,
                },
                {
                    name: "WOL opłacony",
                    value: 72,
                },
                {
                    name: "Konieczność opłaty WOL (wybór płatności)",
                    value: 73,
                },
                {
                    name: "Ponów płatność WOL",
                    value: 74,
                },
                {
                    name: "Weryfikacja podpisu kwalifikowanego",
                    value: 76,
                },
                {
                    name: "Akceptacja",
                    value: 80,
                },
                {
                    name: "Akceptacja z warunkami",
                    value: 90,
                },
                {
                    name: "Do zmiany przez operatora",
                    value: 91,
                },
                {
                    name: "Zmiana formy finansowania",
                    value: 92,
                },
                {
                    name: "Zmiana zamówienia przez Klienta",
                    value: 95,
                },
                {
                    name: "Rolnik",
                    value: 98,
                },
                {
                    name: "Odrzucenie",
                    value: 100,
                },
                {
                    name: "Akceptacja nowych warunków",
                    value: 103,
                },
                {
                    name: "Umowa przygotowana",
                    value: 105,
                },
                {
                    name: "Umowa zawiera niepoprawne dane",
                    value: 106,
                },
                {
                    name: "Umowa jest poprawna",
                    value: 107,
                },
                {
                    name: "Umowa przekazana do klienta",
                    value: 110,
                },
                {
                    name: "Umowa u kuriera",
                    value: 111,
                },
                {
                    name: "Umowa zaakceptowana przez klienta",
                    value: 120,
                },
                {
                    name: "Zapłacone częściowo",
                    value: 124,
                },
                {
                    name: "Płatność do dostawcy",
                    value: 125,
                },
                {
                    name: "EDEN umowa potwierdzona",
                    value: 127,
                },
                {
                    name: "Płatność do dostawcy - oczekiwanie",
                    value: 128,
                },
                {
                    name: "Umowa odrzucona przez klienta",
                    value: 130,
                },
                {
                    name: "mSzafir - manualny proces zawarcia umowy",
                    value: 131,
                },
                {
                    name: "mSzafir - oczekiwanie na podpisanie dokumentu",
                    value: 132,
                },
                {
                    name: "Umowa podpisana. Towar do wydania",
                    value: 140,
                },
                {
                    name: "Czekamy na spłatę w terminie odroczenia",
                    value: 141,
                },
                {
                    name: "Umowa spłacona w terminie odroczenia",
                    value: 142,
                },
                {
                    name: "Zamówienie zostało rozłożone na raty",
                    value: 143,
                },
                {
                    name: "Umowa ramowa - oczekuje na zawarcie umowy",
                    value: 151,
                },
                {
                    name: "Umowa ramowa - uruchomiona",
                    value: 153,
                },
                {
                    name: "Umowa ramowa - wypowiedziana",
                    value: 155,
                },
                {
                    name: "Umowa ramowa - do płatności",
                    value: 157,
                },
                {
                    name: "Umowa potwierdzona - wyślij towar",
                    value: 200,
                },
                {
                    name: "Karencja - iPhone 15",
                    value: 201,
                },
                {
                    name: "Towar u kuriera",
                    value: 210,
                },
                {
                    name: "Towar odebrany",
                    value: 220,
                },
                {
                    name: "Towar odebrany przez klienta",
                    value: 310,
                },
                {
                    name: "Oczekiwanie na zamówienie",
                    value: 398,
                },
                {
                    name: "Brak IBAN",
                    value: 399,
                },
                {
                    name: "Korekta danych BR (AML)",
                    value: 442,
                },
                {
                    name: "Wymaga uzupełnienia danych przez sklep",
                    value: 500,
                },
                {
                    name: "Nie wymaga uzupełnienia danych przez sklep",
                    value: 505,
                },
                {
                    name: "Podpisanie umowy oraz odbiór towaru w punkcie sprzedaży",
                    value: 507,
                },
                {
                    name: "Umowa uzupełniona przez sklep",
                    value: 510,
                },
                {
                    name: "Ostateczne sprawdzenie poprawności",
                    value: 600,
                },
                {
                    name: "Automat - pobieranie danych dostawcy",
                    value: 663,
                },
                {
                    name: "Automat - oczekiwanie na dane dostawców",
                    value: 664,
                },
                {
                    name: "Automat - weryfikacja dostawców",
                    value: 665,
                },
                {
                    name: "Cesja Zaakceptowana",
                    value: 700,
                },
                {
                    name: "Wniosek zakończony",
                    value: 701,
                },
                {
                    name: "Cesja zaakceptowana z poręczeniem",
                    value: 702,
                },
                {
                    name: "(Cesja) Dokumenty wysłane do Klienta",
                    value: 703,
                },
                {
                    name: "(Cesja) Dokumenty błędnie podpisane",
                    value: 704,
                },
                {
                    name: "Cesja wprowadzona",
                    value: 705,
                },
                {
                    name: "Cesja anulowana",
                    value: 706,
                },
                {
                    name: "Obsługa rezygnacji",
                    value: 800,
                },
                {
                    name: "Obsługa anulacji",
                    value: 801,
                },
                {
                    name: "Proces zakończony",
                    value: 1000,
                },
            ];
            $scope.chunkStatuses = chunk($scope.AllStatuses, 3);
            $scope.filterRequestStatuses = function (item) {
                if ($scope.searchStatuses.name) {
                    var _v0 = ($scope.searchStatuses.name || "").toLowerCase();
                    var _v1 = (item.name + "" || "").toLowerCase();
                    if (_v1.indexOf(_v0) == -1)
                        return false;
                }
                return true;
            };
            // funkcja do dzielenia na kolumny
            function chunk(arr, size) {
                var newArr = [];
                for (var i = 0; i < arr.length; i += size) {
                    newArr.push(arr.slice(i, i + size));
                }
                return newArr;
            }
            $scope.$watch("searchStatuses", function () {
                $scope.filteredStatusesList = filterFilter($scope.AllStatuses, $scope.filterRequestStatuses);
                $scope.chunkedStatuses = chunk($scope.filteredStatusesList, 3);
            }, true);
            $scope.updateSelection = function ($event, value) {
                var checkbox = $event.target;
                var action = checkbox.checked ? "add" : "remove";
                updateSelected(action, value);
            };
            var updateSelected = function (action, value) {
                if (action === "add" &&
                    $scope.currentUser.DefaultStatuses.indexOf(value) === -1) {
                    $scope.currentUser.DefaultStatuses.push(value);
                }
                if (action === "remove" &&
                    $scope.currentUser.DefaultStatuses.indexOf(value) !== -1) {
                    $scope.currentUser.DefaultStatuses.splice($scope.currentUser.DefaultStatuses.indexOf(value), 1);
                }
            };
            $scope.isSelected = function (value) {
                return $scope.currentUser.DefaultStatuses.indexOf(value) >= 0;
            };
        }
        UsersCtrl.$inject = [
            "$rootScope",
            "$scope",
            "$location",
            "$http",
            "toaster",
            "$modal",
            "filterFilter",
            "SystemDataHelper",
        ];
        return UsersCtrl;
    }());
    system.UsersCtrl = UsersCtrl;
    /* dane uzytkownika */ // przeniesione z modala na stronę - do kontrolera UsersCtrl
    var UserCtrl = (function () {
        function UserCtrl($rootScope, $scope, $modalInstance, toaster, $http, item, PartnerSupervisors, Roles) {
            item.AccessAPI = item.Roles.indexOf("AccessAPI") > -1;
            item.AccessKalkSklep = item.Roles.indexOf("RateCalculator") > -1;
            item.AccessOpenKlient = item.Roles.indexOf("SecuredMakeNew") > -1;
            item.AccessOpenPartner = item.Roles.indexOf("ProcessOfferByPartner") > -1;
            $scope.item = item;
            $scope.PartnerSupervisors = PartnerSupervisors;
            $scope.Partners = [];
            $scope.Roles = Roles;
            // pobranie partnerow
            $http.get("/offerbusinessdata/getpartnersbase").then(function (d) {
                $scope.Partners = [];
                $scope.Partners = _.map(d.data, function (i) {
                    return { k: i.Key, v: i.Name, url: i.PartnerUrl };
                });
            }, function (e) {
                console.error(e);
            });
            // oddanie danych
            $scope.saveItem = function () {
                $http.post("/api/User", $scope.item).then(function (d) {
                    $scope.item = d.data.Result;
                    $modalInstance.close($scope.item);
                }, function (e) {
                    console.error(e);
                    toaster.pop("error", "Użytkownicy", "Użytkownik o podanym EXTERNAL ID już istnieje");
                });
            };
            // zamkniecie
            $scope.cancel = function () {
                $scope.item.EditMode = false;
                $modalInstance.dismiss("cancel");
            };
        }
        UserCtrl.$inject = [
            "$rootScope",
            "$scope",
            "$modalInstance",
            "toaster",
            "$http",
            "item",
            "PartnerSupervisors",
            "Roles",
        ];
        return UserCtrl;
    }());
    system.UserCtrl = UserCtrl;
    /* haslo uzytkownika */
    var UserPasswordCtrl = (function () {
        function UserPasswordCtrl($scope, $modalInstance, $http, item, toaster) {
            $scope.passwordModel = {
                Password: "",
                PasswordRepeat: "",
            };
            // oddanie danych
            $scope.saveItem = function () {
                $http
                    .post("/api/PartnerUserSetPassword/", {
                    UserId: item.Id,
                    Password: $scope.passwordModel.Password,
                    PasswordRepeat: $scope.passwordModel.PasswordRepeat,
                })
                    .then(function (d) {
                    $modalInstance.close($scope.item);
                    toaster.pop("success", "Użytkownicy", "Hasło zostało zmienione");
                }, function (e) {
                    toaster.pop("error", "Użytkownicy", "Zmiana hasła nie powiodła się");
                });
            };
            // zamkniecie
            $scope.cancel = function () {
                $modalInstance.dismiss("cancel");
            };
        }
        UserPasswordCtrl.$inject = ["$scope", "$modalInstance", "$http", "item", "toaster"];
        return UserPasswordCtrl;
    }());
    system.UserPasswordCtrl = UserPasswordCtrl;
    var LlUserHierarchyDirective = (function () {
        function LlUserHierarchyDirective(toaster, $http, $modal) {
            this.toaster = toaster;
            this.$http = $http;
            this.$modal = $modal;
            this.restrict = "AE";
            this.scope = {
                currentUserGuid: "=",
                usersList: "=",
            };
            this.templateUrl = "/WWW/partials/modules/user.hierarchy.html";
            this.link = function (scope, elem, attr) {
                scope.findSubordinates = function (list, supervisorGuid) {
                    return _.filter(list, function (user) {
                        return user.PartnerSupervisor_Guid === supervisorGuid;
                    });
                };
                scope.makeNode = function (supervisorGuid) {
                    var subordinates = scope.findSubordinates(scope.usersList, supervisorGuid);
                    var current = _.findWhere(scope.usersList, {
                        Guid: supervisorGuid,
                    });
                    var nodeUser = {};
                    if (current) {
                        nodeUser = {
                            FirstName: current.FirstName,
                            LastName: current.LastName,
                            Email: current.Email,
                            Partner: current.Partner,
                            subordinates: _.map(subordinates, function (user) {
                                return scope.makeNode(user.Guid);
                            }),
                        };
                    }
                    return nodeUser;
                };
                scope.toggle = function (s) {
                    s.toggle();
                };
                scope.currentUser = scope.makeNode(scope.currentUserGuid);
            };
        }
        LlUserHierarchyDirective.Factory = function () {
            var dir = function (toaster, $http, $modal) {
                return new LlUserHierarchyDirective(toaster, $http, $modal);
            };
            dir["$inject"] = ["toaster", "$http", "$modal"];
            return dir;
        };
        return LlUserHierarchyDirective;
    }());
    system.LlUserHierarchyDirective = LlUserHierarchyDirective;
})(system || (system = {}));
var clientConsents;
(function (clientConsents) {
    var ClientConsentsSrv = (function () {
        function ClientConsentsSrv($http) {
            var _this = this;
            this.$http = $http;
            // pobranie zestawu zgod
            this.getConsentList = function (partner, processStage) {
                var url = '/api/RodoConstent?type=';
                if (partner) {
                    url += '&partner=' + (partner);
                }
                if (processStage) {
                    url += '&processStage=' + (processStage);
                }
                return _this.$http.get(url);
            };
            // pobranie zgod na procesie
            this.getProcessConsents = function (orderId) {
                var url = '/api/get-rodo-consent-for-offer?orderId=' + orderId;
                return _this.$http.get(url);
            };
        }
        ClientConsentsSrv.$inject = ['$http'];
        return ClientConsentsSrv;
    }());
    clientConsents.ClientConsentsSrv = ClientConsentsSrv;
    var ClientConsentsCtrl = (function () {
        function ClientConsentsCtrl($scope, $service) {
            var _this = this;
            this.$service = $service;
            // pobranie danych
            $scope.refresh = function () {
                // pobranie stage
                var partner = $scope.formRequest.PartnerName || 'LEASELINK';
                // // chwilowa klazula na wyłączność
                // if (['BOSBANK', 'ING-BANK'].indexOf(partner.toUpperCase()) === -1) {
                //     partner = 'LEASELINK';
                // }
                //const partner = 'LEASELINK';
                var stage = $scope.step;
                _this.$service.getConsentList(partner, stage).then(function (d) {
                    $scope.consents = d.data.Result;
                }, function (e) { });
                // pobranie zgód rodo 
                _this.$service.getProcessConsents($scope.formRequest.AggragatedCalulationId).then(function (d) {
                    $scope.processConsents = d.data.Result;
                }, function (e) { });
            };
            $scope.initCheckbox = function (consentGuid) {
                var consentInitialValue = false;
                for (var i = 0; i <= $scope.formRequest.Requestors[0].Consents.length - 1; i++) {
                    var _processConsent = $scope.formRequest.Requestors[0].Consents[i];
                    if (_processConsent.Guid === consentGuid) {
                        if (_processConsent.Agreed) {
                            consentInitialValue = true;
                        }
                        else {
                            consentInitialValue = false;
                        }
                    }
                }
                return { Agreed: consentInitialValue, isCollapsed: false };
            };
            // obserwacja zmian
            $scope.$watch('consentsModel', function (n, o) {
                var keys = Object.keys(n);
                for (var i = 0; i <= keys.length - 1; i++) {
                    var key = keys[i];
                    var consent = n[key];
                    var found = false;
                    for (var j = 0; j <= $scope.formRequest.Requestors[0].Consents.length - 1; j++) {
                        var _consent = $scope.formRequest.Requestors[0].Consents[j];
                        if (_consent.Guid === key) {
                            _consent.Agreed = consent.Agreed;
                            found = true;
                            break;
                        }
                    }
                    if (found !== true) {
                        $scope.formRequest.Requestors[0].Consents.push({
                            Guid: key,
                            Agreed: consent.Agreed
                        });
                    }
                }
            }, true);
            // obserwacja forma
            $scope.$watch('formRequest', function () {
                if ($scope.formRequest && $scope.formRequest.Requestors && $scope.formRequest.Requestors.length > 0) {
                    $scope.formRequest.Requestors[0].Consents = $scope.formRequest.Requestors[0].Consents || [];
                    $scope.refresh();
                }
            });
            // zmiana check all
            $scope.$watch('checkAll', function () {
                var keys = Object.keys($scope.consentsModel);
                for (var i = 0; i <= keys.length - 1; i++) {
                    var _key = keys[i];
                    $scope.consentsModel[_key].Agreed = ($scope.checkAll === true);
                }
            });
            // zmiana check all
            $scope.$watch('selectAll', function () {
                var keys = Object.keys($scope.consentsModel);
                for (var i = 0; i <= keys.length - 1; i++) {
                    var _key = keys[i];
                    $scope.consentsModel[_key].Agreed = ($scope.selectAll === true);
                }
            });
            // lista zgód
            $scope.consents = [];
            $scope.processConsents = [];
            $scope.consentsModel = {};
            $scope.selectAll = false;
        }
        ClientConsentsCtrl.$inject = ['$scope', 'ClientConsentsSrv'];
        return ClientConsentsCtrl;
    }());
    clientConsents.ClientConsentsCtrl = ClientConsentsCtrl;
    var ClientConsentsDir = (function () {
        function ClientConsentsDir() {
            this.restrict = "AE";
            this.template = "\n        <div ng-show=\"consents.length > 0\" class=\"client-consents-container\">\n        <table class=\"dane\">\n        <tr>\n            <td>\n            <div ng-show=\"consents.length > 1\">\n                <label class=\"checkbox-inline\" for=\"selectAll\">\n                    <input name=\"selectAll\" id=\"selectAll\" type=\"checkbox\" ng-disabled=\"isFormValidated\" ng-model=\"selectAll\" ng-checked=\"selectAll\" />\n                    <span>Zaznacz wszystkie</span>\n                </label>\n            </div>\n\n            <div  ng-repeat=\"consent in consents\" class=\"client-consent-container\">\n            <ng-form name=\"consentForm\">\n                <label class=\"checkbox-inline\" for=\"Agreed\" style=\"\" ng-init=\"consentsModel[consent.Guid] = { Agreed: false , isCollapsed: false }\">\n                    <input name=\"Agreed\" type=\"checkbox\" ng-disabled=\"isFormValidated\" ng-model=\"consentsModel[consent.Guid].Agreed\" ng-checked=\"consentsModel[consent.Guid].Agreed\" ng-required=\"consent.Obligatory === true\" class=\"\">\n                    <span class=\"req\" ng-show=\"consentForm.Agreed.$error.required\" style=\"margin-right: 5px;\">Niezb\u0119dne *</span>\n                    <span>{{consent.Code}}</span>\n                    <a class=\"show-more\" ng-click=\"consentsModel[consent.Guid].isCollapsed = !consentsModel[consent.Guid].isCollapsed\">Zobacz pe\u0142n\u0105 tre\u015B\u0107 \u00BB</a>\n                </label>\n\n                <div collapse=\"consentsModel[consent.Guid].isCollapsed !== true\" class=\"in\" style=\"height: auto;\">\n                    <div class=\"well well-sm\" ng-bind-html=\"consent.Text\"></div>\n                </div>\n            </ng-form>\n            </div>\n\n            </td>\n        </tr>\n        </table>\n        <div ng-show=\"!simpleForm\" class=\"rodo-add-info\">*Prosimy o wyra\u017Cenie zg\u00F3d na kontakt niezb\u0119dnych dla realizacji Twojej oferty. Ze wzgl\u0119du na ca\u0142kowicie on-lineowy charakter naszego procesu, od poznania oferty, a\u017C po zawarcie transakcji, brak Twojej zgody uniemo\u017Cliwi nam spe\u0142nienie Twoich potrzeb w ci\u0105gu kilku minut, 24/7/365. Podanie numeru NIP, numeru telefonu oraz adresu e-mail nie jest wymogiem ustawowym, jednak\u017Ce jest wymagane je\u015Bli chc\u0105 Pa\u0144stwo skorzysta\u0107 z naszych us\u0142ug.</div>\n        </div>\n        ";
            this.controller = ClientConsentsCtrl;
            this.scope = {
                step: "@",
                formRequest: "=",
                checkAll: "=",
                simpleForm: "=" // ukrywa napis pod zgodami
            };
        }
        ClientConsentsDir.Factory = function () {
            var d = function () { return new ClientConsentsDir(); };
            d['$inject'] = [];
            return d;
        };
        return ClientConsentsDir;
    }());
    clientConsents.ClientConsentsDir = ClientConsentsDir;
    var ClientConsentsNewDir = (function () {
        function ClientConsentsNewDir() {
            this.restrict = "AE";
            this.template = "\n        <div class=\"client-consents-container\">\n        <table class=\"dane\">\n        <tr>\n            <td>\n\n            <label class=\"checkbox-inline\" for=\"selectAll\">\n                <input name=\"selectAll\" id=\"selectAll\" type=\"checkbox\" ng-disabled=\"isFormValidated\" ng-model=\"selectAll\" ng-checked=\"selectAll\" />\n                <span>Zaznacz wszystkie</span>\n            </label>\n\n            <div  ng-repeat=\"consent in consents\" class=\"client-consent-container\">\n            <ng-form name=\"consentForm\">\n                <label class=\"checkbox-inline\" for=\"Agreed\" style=\"\" ng-init=\"consentsModel[consent.Guid] = { Agreed: false , isCollapsed: false }\">\n                    <input name=\"Agreed\" type=\"checkbox\" ng-disabled=\"isFormValidated\" ng-model=\"consentsModel[consent.Guid].Agreed\" ng-checked=\"consentsModel[consent.Guid].Agreed\" ng-required=\"consent.Obligatory === true\" class=\"\">\n                    <span class=\"req\" ng-show=\"consentForm.Agreed.$error.required\" style=\"margin-right: 5px;\">Niezb\u0119dne *</span>\n                    <span>{{consent.Code}}</span>\n                    <a class=\"show-more\" ng-click=\"consentsModel[consent.Guid].isCollapsed = !consentsModel[consent.Guid].isCollapsed\">Zobacz pe\u0142n\u0105 tre\u015B\u0107 \u00BB</a>\n                </label>\n\n                <div collapse=\"consentsModel[consent.Guid].isCollapsed !== true\" class=\"in\" style=\"height: auto;\">\n                    <div class=\"well well-sm\" ng-bind-html=\"consent.Text\"></div>\n                </div>\n            </ng-form>\n            </div>\n\n            </td>\n        </tr>\n        </table>\n        <div class=\"rodo-add-info\">*Prosimy o wyra\u017Cenie zg\u00F3d na kontakt niezb\u0119dnych dla realizacji oferty Klienta. Ze wzgl\u0119du na ca\u0142kowicie on-lineowy charakter naszego procesu, od poznania oferty, a\u017C po zawarcie transakcji, brak zgody uniemo\u017Cliwi nam spe\u0142nienie jego potrzeb w ci\u0105gu kilku minut, 24/7/365. Podanie numeru NIP, numeru telefonu oraz adresu e-mail nie jest wymogiem ustawowym, jednak\u017Ce jest wymagane je\u015Bli chc\u0105 Pa\u0144stwo skorzysta\u0107 z naszych us\u0142ug. Klient w dowolnej chwili mo\u017Ce usun\u0105\u0107 swoje zgody.</div>\n\n        </div>\n        ";
            this.controller = ClientConsentsCtrl;
            this.scope = {
                step: "@",
                formRequest: "=",
                checkAll: "="
            };
        }
        ClientConsentsNewDir.Factory = function () {
            var d = function () { return new ClientConsentsNewDir(); };
            d['$inject'] = [];
            return d;
        };
        return ClientConsentsNewDir;
    }());
    clientConsents.ClientConsentsNewDir = ClientConsentsNewDir;
    var ClientConsentsInnerDir = (function () {
        function ClientConsentsInnerDir() {
            this.restrict = "AE";
            this.template = "\n\n        <div  ng-repeat=\"consent in consents\" class=\"client-consent-container\">\n        <ng-form name=\"consentForm\">\n            <label class=\"checkbox-inline\" for=\"Agreed\" style=\"font-weight: bold;\" ng-init=\"consentsModel[consent.Guid] = initCheckbox(consent.Guid)\">\n                <input name=\"Agreed\" type=\"checkbox\" ng-disabled=\"isFormValidated\" ng-model=\"consentsModel[consent.Guid].Agreed\" ng-checked=\"consentsModel[consent.Guid].Agreed\" ng-required=\"consent.Obligatory === true\" class=\"\">\n                <span class=\"req\" ng-show=\"consentForm.Agreed.$error.required\" style=\"margin-right: 5px;\">Niezb\u0119dne *</span>\n                <span>{{consent.Code}}</span>\n                <a class=\"show-more\" ng-click=\"consentsModel[consent.Guid].isCollapsed = !consentsModel[consent.Guid].isCollapsed\">Zobacz pe\u0142n\u0105 tre\u015B\u0107 \u00BB</a>\n            </label>\n\n            <div collapse=\"consentsModel[consent.Guid].isCollapsed !== true\" class=\"in\" style=\"height: auto;\">\n                <div class=\"well well-sm\" ng-bind-html=\"consent.Text\"></div>\n            </div>\n        </ng-form>\n        </div>\n\n\n        ";
            this.controller = ClientConsentsCtrl;
            this.scope = {
                step: "@",
                formRequest: "=",
                checkAll: "="
            };
        }
        ClientConsentsInnerDir.Factory = function () {
            var d = function () { return new ClientConsentsInnerDir(); };
            d['$inject'] = [];
            return d;
        };
        return ClientConsentsInnerDir;
    }());
    clientConsents.ClientConsentsInnerDir = ClientConsentsInnerDir;
    var ClientConsentsInfoDir = (function () {
        function ClientConsentsInfoDir() {
            this.template = "\n        <div class=\"rodo-info-container\">\n            <div class=\"content\">\n                <a target=\"_blank\" href=\"https://leaselink.pl/obowiazek-informacyjny\">RODO - Obowi\u0105zek informacyjny.</a>\n            </div>\n        </div>\n        ";
        }
        ClientConsentsInfoDir.Factory = function () {
            var d = function () { return new ClientConsentsInfoDir(); };
            d['$inject'] = [];
            return d;
        };
        return ClientConsentsInfoDir;
    }());
    clientConsents.ClientConsentsInfoDir = ClientConsentsInfoDir;
})(clientConsents || (clientConsents = {}));
angular.module("ll.client.consents", ['ngSanitize'])
    .directive("llClientConsents", clientConsents.ClientConsentsDir.Factory())
    .directive("llClientConsentsNew", clientConsents.ClientConsentsNewDir.Factory())
    .directive("llClientConsentsInner", clientConsents.ClientConsentsInnerDir.Factory())
    .directive("llClientConsentsInfo", clientConsents.ClientConsentsInfoDir.Factory())
    .service("ClientConsentsSrv", clientConsents.ClientConsentsSrv);
var clientDirectives;
(function (clientDirectives) {
    /** process stage */
    var ngProcessMultiStepsCtrl = (function () {
        function ngProcessMultiStepsCtrl($scope) {
            //zmienne
            $scope.numberOfSteps = ($scope.partner && $scope.userLogged) ? 6 : 5;
            $scope.currentStep = 0;
            $scope.isVisible = false;
            $scope.partnerPosition = (($scope.partner && $scope.userLogged) ? 'top' : 'bottom');
            if ($scope.position && $scope.position == $scope.partnerPosition) {
                $scope.isVisible = true;
            }
            else if (!$scope.position) {
                $scope.isVisible = true;
            }
            else {
                $scope.isVisible = false;
            }
            // przemapowanie krokow
            switch ($scope.step) {
                case "step0":
                    $scope.currentStep = 0;
                    break;
                case "step1":
                    $scope.currentStep = 1;
                    break;
                case "step2":
                    $scope.currentStep = 2;
                    break;
                case "step3":
                    $scope.currentStep = 3;
                    break;
                case "step4":
                    $scope.currentStep = 4;
                    break;
                case "step5":
                    $scope.currentStep = 5;
                    break;
            }
        }
        ngProcessMultiStepsCtrl.$inject = ['$scope'];
        return ngProcessMultiStepsCtrl;
    }());
    var ngProcessMultiSteps = (function () {
        function ngProcessMultiSteps() {
            this.controller = ngProcessMultiStepsCtrl;
            this.restrict = "AE";
            this.scope = {
                step: "@",
                partner: "=",
                position: "@",
                userLogged: "="
            };
            this.templateUrl = "/WWW/partials/process.steps.directive.html";
        }
        ngProcessMultiSteps.Factory = function () {
            var dir = function () { return new ngProcessMultiSteps(); };
            dir['$inject'] = [];
            return dir;
        };
        return ngProcessMultiSteps;
    }());
    clientDirectives.ngProcessMultiSteps = ngProcessMultiSteps;
    /** side up drawer */
    var ngProcessSideDrawerCtrl = (function () {
        function ngProcessSideDrawerCtrl($scope) {
            $scope.showDrawer = function () {
                $scope.isDrawerVisible = true;
            };
            $scope.closeDrawer = function () {
                $scope.isDrawerVisible = false;
            };
            // zmienne
            $scope.isDrawerVisible = false;
            // czy wogole dostepy
            $scope.isDrawerAvaiable = ($scope.userLogged && $scope.partner) || false; // ['MEDMRK'].indexOf($scope.partner) !== -1;
        }
        ngProcessSideDrawerCtrl.$inject = ['$scope'];
        return ngProcessSideDrawerCtrl;
    }());
    var ngProcessSideDrawer = (function () {
        function ngProcessSideDrawer() {
            this.controller = ngProcessSideDrawerCtrl;
            this.restrict = "AE";
            this.replace = true;
            this.scope = {
                step: "@",
                partner: "=",
                userLogged: "="
            };
            this.templateUrl = "/WWW/partials/modules/process.drawer.directive.html";
        }
        ngProcessSideDrawer.Factory = function () {
            var dir = function () { return new ngProcessSideDrawer(); };
            dir['$inject'] = [];
            return dir;
        };
        return ngProcessSideDrawer;
    }());
    clientDirectives.ngProcessSideDrawer = ngProcessSideDrawer;
    /** koszyk na createoffer */
    var ngCreateOfferCartCtrl = (function () {
        function ngCreateOfferCartCtrl($scope) {
        }
        ngCreateOfferCartCtrl.$inject = ['$scope'];
        return ngCreateOfferCartCtrl;
    }());
    var ngCreateOfferCart = (function () {
        function ngCreateOfferCart() {
            this.controller = ngCreateOfferCartCtrl;
            this.restrict = "AE";
            this.templateUrl = "/WWW/partials/modules/client.offer/create.offer.cart.html";
        }
        ngCreateOfferCart.Factory = function () {
            var dir = function () { return new ngCreateOfferCart(); };
            dir['$inject'] = [];
            return dir;
        };
        return ngCreateOfferCart;
    }());
    clientDirectives.ngCreateOfferCart = ngCreateOfferCart;
    /** koszyk stacjonarny na createoffer */
    var ngCreateOfferCartStationaryCtrl = (function () {
        function ngCreateOfferCartStationaryCtrl($scope) {
        }
        ngCreateOfferCartStationaryCtrl.$inject = ['$scope'];
        return ngCreateOfferCartStationaryCtrl;
    }());
    var ngCreateOfferCartStationary = (function () {
        function ngCreateOfferCartStationary() {
            this.controller = ngCreateOfferCartStationaryCtrl;
            this.restrict = "AE";
            this.templateUrl = "/WWW/partials/modules/client.offer/create.offer.cart.stationary.html";
        }
        ngCreateOfferCartStationary.Factory = function () {
            var dir = function () { return new ngCreateOfferCartStationary(); };
            dir['$inject'] = [];
            return dir;
        };
        return ngCreateOfferCartStationary;
    }());
    clientDirectives.ngCreateOfferCartStationary = ngCreateOfferCartStationary;
    /** dane klienta na createOffer */
    var ngCreateOfferClientDataCtrl = (function () {
        function ngCreateOfferClientDataCtrl($scope) {
        }
        ngCreateOfferClientDataCtrl.$inject = ['$scope'];
        return ngCreateOfferClientDataCtrl;
    }());
    var ngCreateOfferClientData = (function () {
        function ngCreateOfferClientData() {
            this.controller = ngCreateOfferClientDataCtrl;
            this.restrict = "AE";
            this.templateUrl = "/WWW/partials/modules/client.offer/create.offer.client.data.html";
        }
        ngCreateOfferClientData.Factory = function () {
            var dir = function () { return new ngCreateOfferClientData(); };
            dir['$inject'] = [];
            return dir;
        };
        return ngCreateOfferClientData;
    }());
    clientDirectives.ngCreateOfferClientData = ngCreateOfferClientData;
    /** edycja elementow */
    /** edycja dnaych klienta*/
    var ngClientDataCtrl = (function () {
        function ngClientDataCtrl($scope) {
            //metody
            $scope.editData = function () {
                $scope.isEdited = true;
            };
            $scope.saveData = function () {
                $scope.isEdited = false;
                if (typeof $scope.onSave === "function") {
                    $scope.onSave($scope.request);
                }
            };
            // zmienne
            $scope.isEdited = false;
        }
        ngClientDataCtrl.$inject = ['$scope'];
        return ngClientDataCtrl;
    }());
    var ngClientData = (function () {
        function ngClientData() {
            this.controller = ngClientDataCtrl;
            this.restrict = "AE";
            this.scope = {
                request: "=",
                isEditable: "@",
                onSave: "="
            };
            this.templateUrl = "/WWW/partials/modules/request.client.data.html";
        }
        ngClientData.Factory = function () {
            var d = function () { return new ngClientData(); };
            d['$inject'] = [];
            return d;
        };
        return ngClientData;
    }());
    clientDirectives.ngClientData = ngClientData;
    /** edycja danych adresowych klienta*/
    var ngClientAddressDataCtrl = (function () {
        function ngClientAddressDataCtrl($scope) {
            //metody
            $scope.editData = function () {
                $scope.isEdited = true;
                $scope.request.RequestorAddresses[0].Confirmed = false;
            };
            $scope.confirm = function () {
                $scope.request.RequestorAddresses[0].Confirmed = true;
            };
            // ustawienie informacji o adresie korespondecyjnym 
            $scope.request.RequestorAddresses[0].Required = true;
            // zapisanie danych
            $scope.saveData = function () {
                $scope.isEdited = false;
                // ustawienie informacji o adresie korespondecyjnym 
                $scope.request.RequestorAddresses[0].Required = true;
                // zapisanie danych
                if (typeof $scope.onSave === "function") {
                    $scope.onSave($scope.request);
                }
            };
            // zmienne
            $scope.isEdited = false;
        }
        ngClientAddressDataCtrl.$inject = ['$scope'];
        return ngClientAddressDataCtrl;
    }());
    var ngClientAddressData = (function () {
        function ngClientAddressData() {
            this.controller = ngClientAddressDataCtrl;
            this.restrict = "AE";
            this.scope = {
                request: "=",
                isEditable: "@",
                onSave: "="
            };
            this.templateUrl = "/WWW/partials/modules/request.client.address.data.html";
        }
        ngClientAddressData.Factory = function () {
            var d = function () { return new ngClientAddressData(); };
            d['$inject'] = [];
            return d;
        };
        return ngClientAddressData;
    }());
    clientDirectives.ngClientAddressData = ngClientAddressData;
    var ngClientDocumentsDataSrv = (function () {
        function ngClientDocumentsDataSrv($http, $q) {
            var _this = this;
            this.$http = $http;
            this.$q = $q;
            this.getDocuments = function (id, type) {
                var url = '/api/SecuredBusinessProcessDocumentsForUser/' + id + '?type=' + type;
                return _this.$http.get(url);
            };
            this.sendConfirmation = function (id, fileIds) {
                var url = "/document/confirm/" + id;
                return _this.$http.post(url, fileIds);
            };
        }
        ngClientDocumentsDataSrv.$inject = ['$http', '$q'];
        return ngClientDocumentsDataSrv;
    }());
    clientDirectives.ngClientDocumentsDataSrv = ngClientDocumentsDataSrv;
    /** wyswietlanie dokumentow */
    var ngClientDocumentsDataCtrl = (function () {
        function ngClientDocumentsDataCtrl($rootScope, $scope, service, toaster) {
            this.$scope = $scope;
            this.service = service;
            this.toaster = toaster;
            $scope.Documents = [];
            $scope.$on('selfsevice::refresh', function (evt) {
                $scope.getDocuments();
            });
            $scope.getDocuments = function () {
                service.getDocuments($scope.request.AggragatedCalulationId, 'AGREEMENTS')
                    .then(function (d) {
                    $scope.Documents = d.data.Result || [];
                });
            };
            $scope.showDocument = function (fileId) {
                window.open("/Message/ShowDocument?fileId=" + fileId);
            };
            // wyslanie wiadomosci
            $scope.sendMessageToLeaseLink = function () {
                $rootScope.$broadcast("send::messageToLeaselink", { RequestId: $scope.request.AggragatedCalulationId });
            };
            $scope.confirmDocument = function (fileId, params) {
                var _params = params || {};
                var id = $scope.request.AggragatedCalulationId;
                var fileIds = [];
                fileIds.push(fileId);
                if ($scope.user.Role === '' || confirm("Czy na pewno chcesz potwierdzić zapoznanie się z dokumentem?")) {
                    service.sendConfirmation(id, fileIds).then(function (d) {
                        toaster.pop('success', "Potwierdzanie dokumentu", "Dokument potwierdzono poprawnie.");
                        if (_params && typeof _params.callBack === "function") {
                            _params.callBack();
                        }
                        else {
                            // pokazanie zapytania
                            $scope.showRequest(id);
                        }
                    }, function (e) {
                        toaster.pop('error', "Potwierdzanie dokumentu", "Wystąpił błąd podczas potwierdzania dokumentu.");
                    });
                }
            };
            $scope.confirmDocumentWithNoReaload = function (doc) {
                $scope.confirmDocument(doc.FileId, { callBack: function () { doc.Confirmed = true; } });
            };
            $scope.getDocuments();
        }
        ;
        ngClientDocumentsDataCtrl.$inject = ['$rootScope', '$scope', 'ngClientDocumentsDataSrv', 'toaster'];
        return ngClientDocumentsDataCtrl;
    }());
    var ngClientDocumentsData = (function () {
        function ngClientDocumentsData($rootScope) {
            this.$rootScope = $rootScope;
            this.controller = ngClientDocumentsDataCtrl;
            this.restrict = "AE";
            this.scope = {
                request: "=",
                user: "=",
            };
            this.link = function (scope, elem, attr) {
            };
            this.templateUrl = "/WWW/partials/modules/request.client.documents.data.html";
        }
        ngClientDocumentsData.Factory = function () {
            var d = function ($rootScope) { return new ngClientDocumentsData($rootScope); };
            d['$inject'] = ['$rootScope'];
            return d;
        };
        return ngClientDocumentsData;
    }());
    clientDirectives.ngClientDocumentsData = ngClientDocumentsData;
    /** edycja danych adresowych podpisania umowy*/
    var ngClientDeliveryDataCtrl = (function () {
        function ngClientDeliveryDataCtrl($scope) {
            //metody
            $scope.editData = function () {
                $scope.isEdited = true;
                $scope.request.RequestorDeliveryAddress.Confirmed = false;
            };
            $scope.confirm = function () {
                $scope.request.RequestorDeliveryAddress.Confirmed = true;
            };
            $scope.copy = function () {
                var address = JSON.parse(JSON.stringify($scope.request.RequestorAddresses[0]));
                address.Confirmed = false;
                $scope.request.RequestorDeliveryAddress = address;
            };
            // dodanie informacji o zmianie adresu
            $scope.request.RequestorDeliveryAddress.Required = true;
            // zapisanie 
            $scope.saveData = function () {
                $scope.isEdited = false;
                // dodanie informacji o zmianie adresu
                $scope.request.RequestorDeliveryAddress.Required = true;
                // zapisanie 
                if (typeof $scope.onSave === "function") {
                    $scope.onSave($scope.request);
                }
            };
        }
        ngClientDeliveryDataCtrl.$inject = ['$scope'];
        return ngClientDeliveryDataCtrl;
    }());
    var ngClientDeliveryData = (function () {
        function ngClientDeliveryData() {
            this.controller = ngClientDeliveryDataCtrl;
            this.restrict = "AE";
            this.scope = {
                request: "=",
                isEditable: "@",
                onSave: "="
            };
            this.templateUrl = "/WWW/partials/modules/request.client.delivery.data.html";
        }
        ngClientDeliveryData.Factory = function () {
            var d = function () { return new ngClientDeliveryData(); };
            d['$inject'] = [];
            return d;
        };
        return ngClientDeliveryData;
    }());
    clientDirectives.ngClientDeliveryData = ngClientDeliveryData;
    /** edycja danych adresowych odbioru sprzętu*/
    var ngClientCollectDataCtrl = (function () {
        function ngClientCollectDataCtrl($scope) {
            //metody
            $scope.editData = function () {
                $scope.isEdited = true;
                $scope.request.RequestorCollectAddress.Confirmed = false;
            };
            $scope.confirm = function () {
                if ($scope.request.TypeOfItemCollect === 1) {
                    $scope.request.RequestorCollectAddress.Required = true;
                    $scope.request.RequestorSelfCollectAddress.Required = false;
                }
                $scope.request.RequestorCollectAddress.Confirmed = true;
            };
            $scope.copy = function () {
                var address = JSON.parse(JSON.stringify($scope.request.RequestorAddresses[0]));
                address.Confirmed = false;
                $scope.request.RequestorCollectAddress = address;
            };
            // dodanie informacji o zmianie adresu
            $scope.request.RequestorCollectAddress.Required = true;
            // zapisanie 
            $scope.saveData = function () {
                $scope.isEdited = false;
                // dodanie informacji o zmianie adresu
                $scope.request.RequestorCollectAddress.Required = true;
                $scope.request.RequestorSelfCollectAddress.Required = false;
                // zapisanie 
                if (typeof $scope.onSave === "function") {
                    $scope.onSave($scope.request);
                }
            };
        }
        ngClientCollectDataCtrl.$inject = ['$scope'];
        return ngClientCollectDataCtrl;
    }());
    var ngClientCollectData = (function () {
        function ngClientCollectData() {
            this.controller = ngClientCollectDataCtrl;
            this.restrict = "AE";
            this.scope = {
                request: "=",
                isEditable: "@",
                onSave: "="
            };
            this.templateUrl = "/WWW/partials/modules/request.client.collect.adress.data.html";
        }
        ngClientCollectData.Factory = function () {
            var d = function () { return new ngClientCollectData(); };
            d['$inject'] = [];
            return d;
        };
        return ngClientCollectData;
    }());
    clientDirectives.ngClientCollectData = ngClientCollectData;
    /** edycja danych adresowych odbioru sprzętu*/
    var ngClientSelfCollectDataCtrl = (function () {
        function ngClientSelfCollectDataCtrl($scope) {
            //metody
            $scope.editData = function () {
                $scope.isEdited = true;
                $scope.request.RequestorSelfCollectAddress.Confirmed = false;
            };
            $scope.confirm = function () {
                if ($scope.request.TypeOfItemCollect === 0) {
                    $scope.request.RequestorCollectAddress.Required = false;
                    $scope.request.RequestorSelfCollectAddress.Required = true;
                }
                $scope.request.RequestorSelfCollectAddress.Confirmed = true;
            };
            // dodanie informacji o zmianie adresu
            $scope.request.RequestorSelfCollectAddress.Required = true;
            // zapisanie 
            $scope.saveData = function () {
                $scope.isEdited = false;
                // dodanie informacji o zmianie adresu
                $scope.request.RequestorSelfCollectAddress.Required = true;
                $scope.request.RequestorCollectAddress.Required = false;
                // zapisanie 
                if (typeof $scope.onSave === "function") {
                    $scope.onSave($scope.request);
                }
            };
        }
        ngClientSelfCollectDataCtrl.$inject = ['$scope'];
        return ngClientSelfCollectDataCtrl;
    }());
    var ngClientSelfCollectData = (function () {
        function ngClientSelfCollectData() {
            this.controller = ngClientSelfCollectDataCtrl;
            this.restrict = "AE";
            this.scope = {
                request: "=",
                isEditable: "@",
                onSave: "="
            };
            this.templateUrl = "/WWW/partials/modules/request.client.self.collect.adress.data.html";
        }
        ngClientSelfCollectData.Factory = function () {
            var d = function () { return new ngClientSelfCollectData(); };
            d['$inject'] = [];
            return d;
        };
        return ngClientSelfCollectData;
    }());
    clientDirectives.ngClientSelfCollectData = ngClientSelfCollectData;
    /** edycja danych adresowych odbioru sprzętu*/
    var ngClientSelfCollectDataListCtrl = (function () {
        function ngClientSelfCollectDataListCtrl($scope, service) {
            this.service = service;
            //metody
            $scope.selectedAddress = {};
            service.getExternalStoreAddresses($scope.request.PartnerName)
                .then(function (d) {
                $scope.ADDRESSES = d.data;
                $scope.selectedAddress.address = $scope.mapRequestModelToFormModel($scope.request.RequestorSelfCollectAddress);
            });
            $scope.editData = function () {
                $scope.isEdited = true;
                $scope.request.RequestorSelfCollectAddress.Confirmed = false;
            };
            $scope.confirm = function () {
                if ($scope.request.TypeOfItemCollect === 0) {
                    $scope.request.RequestorCollectAddress.Required = false;
                    $scope.request.RequestorSelfCollectAddress.Required = true;
                }
                $scope.request.RequestorSelfCollectAddress.Confirmed = true;
            };
            $scope.mapFormModelToRequestModel = function () {
                $scope.request.RequestorSelfCollectAddress.PostalCode = $scope.selectedAddress.address.postcode;
                $scope.request.RequestorSelfCollectAddress.District = $scope.selectedAddress.address.voivodeship;
                $scope.request.RequestorSelfCollectAddress.City = $scope.selectedAddress.address.city;
                $scope.request.RequestorSelfCollectAddress.ShopName = $scope.selectedAddress.address.name;
                $scope.request.RequestorSelfCollectAddress.Street = $scope.selectedAddress.address.street;
                $scope.request.RequestorSelfCollectAddress.Confirmed = false;
            };
            $scope.mapRequestModelToFormModel = function (requestModel) {
                var formModel = {
                    postcode: requestModel.PostalCode,
                    voivodeship: requestModel.District,
                    city: requestModel.City,
                    name: requestModel.ShopName,
                    street: requestModel.Street
                };
                return formModel;
            };
            // dodanie informacji o zmianie adresu
            $scope.request.RequestorSelfCollectAddress.Required = true;
            // zapisanie 
            $scope.saveData = function () {
                $scope.isEdited = false;
                // dodanie informacji o zmianie adresu
                $scope.request.RequestorSelfCollectAddress.Required = true;
                $scope.request.RequestorCollectAddress.Required = false;
                // zapisanie 
                if (typeof $scope.onSave === "function") {
                    $scope.onSave($scope.request);
                }
            };
        }
        ngClientSelfCollectDataListCtrl.$inject = ['$scope', 'ngClientSelfCollectDataSrv'];
        return ngClientSelfCollectDataListCtrl;
    }());
    var ngClientSelfCollectDataList = (function () {
        function ngClientSelfCollectDataList() {
            this.controller = ngClientSelfCollectDataListCtrl;
            this.restrict = "AE";
            this.scope = {
                request: "=",
                isEditable: "@",
                onSave: "="
            };
            this.templateUrl = "/WWW/partials/modules/request.client.self.collect.adress.data.list.html";
        }
        ngClientSelfCollectDataList.Factory = function () {
            var d = function () { return new ngClientSelfCollectDataList(); };
            d['$inject'] = [];
            return d;
        };
        return ngClientSelfCollectDataList;
    }());
    clientDirectives.ngClientSelfCollectDataList = ngClientSelfCollectDataList;
    var ngClientSelfCollectDataSrv = (function () {
        function ngClientSelfCollectDataSrv($http, $q) {
            var _this = this;
            this.$http = $http;
            this.$q = $q;
            this.getExternalStoreAddresses = function (partnerName) {
                var url = '/offerBusinessData/GetExternalStoreAddresses?storeName=' + partnerName;
                return _this.$http.get(url);
            };
        }
        ngClientSelfCollectDataSrv.$inject = ['$http', '$q'];
        return ngClientSelfCollectDataSrv;
    }());
    clientDirectives.ngClientSelfCollectDataSrv = ngClientSelfCollectDataSrv;
    /** edycja adresów dostaw produktów (EDEN)*/
    var ngProductDeliveryAddressCtrl = (function () {
        function ngProductDeliveryAddressCtrl($scope) {
            //metody
            $scope.editData = function () {
            };
            $scope.cancel = function () {
            };
            $scope.saveData = function () {
                // dodanie informacji o zmianie adresu
                //$scope.request.ProductDeliveryAddress.Required = true;
                // zapisanie 
                if (typeof $scope.onSave === "function") {
                    $scope.onSave($scope.request);
                }
            };
            $scope.categoryFilter = function (item) {
                return (item.ProductTypeName == "FILTR DO WODY" || item.ProductTypeName == "EXPRESS");
            };
        }
        ngProductDeliveryAddressCtrl.$inject = ['$scope'];
        return ngProductDeliveryAddressCtrl;
    }());
    var ngProductDeliveryAddress = (function () {
        function ngProductDeliveryAddress() {
            this.controller = ngProductDeliveryAddressCtrl;
            this.restrict = "AE";
            this.scope = {
                request: "=",
                isEditable: "@",
                onSave: "="
            };
            this.templateUrl = "/WWW/partials/modules/request.product.delivery.address.html";
        }
        ngProductDeliveryAddress.Factory = function () {
            var d = function () { return new ngProductDeliveryAddress(); };
            d['$inject'] = [];
            return d;
        };
        return ngProductDeliveryAddress;
    }());
    clientDirectives.ngProductDeliveryAddress = ngProductDeliveryAddress;
    /** edycja adresów instalacji do umowy serwisowej (EDEN)*/
    var ngServiceDeliveryAddressCtrl = (function () {
        function ngServiceDeliveryAddressCtrl($scope) {
            //metody
            $scope.editData = function () {
            };
            $scope.cancel = function () {
            };
            $scope.saveData = function () {
                // dodanie informacji o zmianie adresu
                //$scope.request.ProductDeliveryAddress.Required = true;
                // zapisanie 
                if (typeof $scope.onSave === "function") {
                    $scope.onSave($scope.request);
                }
            };
            $scope.categoryFilter = function (item) {
                return (item.ProductTypeName == "SERWIS");
            };
        }
        ngServiceDeliveryAddressCtrl.$inject = ['$scope'];
        return ngServiceDeliveryAddressCtrl;
    }());
    var ngServiceDeliveryAddress = (function () {
        function ngServiceDeliveryAddress() {
            this.controller = ngServiceDeliveryAddressCtrl;
            this.restrict = "AE";
            this.scope = {
                request: "=",
                isEditable: "@",
                onSave: "="
            };
            this.templateUrl = "/WWW/partials/modules/request.service.delivery.address.html";
        }
        ngServiceDeliveryAddress.Factory = function () {
            var d = function () { return new ngServiceDeliveryAddress(); };
            d['$inject'] = [];
            return d;
        };
        return ngServiceDeliveryAddress;
    }());
    clientDirectives.ngServiceDeliveryAddress = ngServiceDeliveryAddress;
    /** dyrektywa edycji adresu*/
    var AddressNewFormCtrl = (function () {
        function AddressNewFormCtrl($scope) {
            // lista prefixow
            $scope.streetPrefixes = [
                'AL.',
                'BULW.',
                'DROGA',
                'INNE',
                'OGRÓD',
                'OS.',
                'PARK',
                'PL.',
                'RONDO',
                'RYNEK',
                'SKWER',
                'SZOSA',
                'UL.',
                'WYB.',
                'WYSPA'
            ];
            // to musi tak byc poniewaz watcher a autocomplete za pozno sie inicjuje
            $scope._isFormValidated = false;
            $scope.isAutoCompleteDisabled = function () {
                return $scope._isFormValidated;
            };
            $scope.$watch('isFormValidated', function () {
                if ($scope.isFormValidated !== $scope._isFormValidated) {
                    setTimeout(function () {
                        $scope._isFormValidated = $scope.isFormValidated;
                    }, 100);
                }
            });
        }
        AddressNewFormCtrl.$inject = ['$scope'];
        return AddressNewFormCtrl;
    }());
    var AddressNewFormDirective = (function () {
        function AddressNewFormDirective() {
            this.controller = AddressNewFormCtrl;
            this.templateUrl = "/WWW/partials/addressNewForm.html";
            this.restrict = "AE";
            this.scope = {
                address: "=",
                isRequired: "=",
                hideSpecificPlace: "=",
                isFormValidated: "=",
                liteForm: "="
            };
        }
        AddressNewFormDirective.Factory = function () {
            var d = function () { return new AddressNewFormDirective(); };
            d['$inject'] = [];
            return d;
        };
        return AddressNewFormDirective;
    }());
    clientDirectives.AddressNewFormDirective = AddressNewFormDirective;
    var AddressNewFormLiteDirective = (function () {
        function AddressNewFormLiteDirective() {
            this.controller = AddressNewFormCtrl;
            this.templateUrl = "/WWW/partials/addressNewFormLite.html";
            this.restrict = "AE";
            this.scope = {
                address: "=",
                isRequired: "=",
                hideSpecificPlace: "=",
                isFormValidated: "=",
                liteForm: "="
            };
        }
        AddressNewFormLiteDirective.Factory = function () {
            var d = function () { return new AddressNewFormLiteDirective(); };
            d['$inject'] = [];
            return d;
        };
        return AddressNewFormLiteDirective;
    }());
    clientDirectives.AddressNewFormLiteDirective = AddressNewFormLiteDirective;
    /*nowa stopka*/
    var FrontFooterDirective = (function () {
        function FrontFooterDirective() {
            this.restrict = "E";
            this.template = "\n<!-- nowy footer -->\n<div class=\"llWrapper\">\n\n    <iframe id=\"llFooter\" src=\"https://leaselink.pl/inc/dynamic-footer.php\" scrolling=\"no\" frameborder=\"0\" style=\"min-height:350px; width:100%;\"></iframe>\n\n</div>\n<script src=\"https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.5.14/iframeResizer.min.js\"></script>\n<script src=\"https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.5.14/iframeResizer.contentWindow.min.js\"></script>\n<script>\n    iFrameResize({\n        log: true,\n        heightCalculationMethod: 'lowestElement'\n    }, '#llFooter')\n</script>\n<!-- nowy footer -->\n        ";
        }
        ;
        FrontFooterDirective.Factory = function () {
            var dir = function () { return new FrontFooterDirective(); };
            dir['$inject'] = [];
            return dir;
        };
        return FrontFooterDirective;
    }());
    clientDirectives.FrontFooterDirective = FrontFooterDirective;
    /*  helper */
    var FrontHelpDirective = (function () {
        function FrontHelpDirective($http, $sce) {
            var _this = this;
            this.$http = $http;
            this.$sce = $sce;
            this.restrict = "E";
            this.template = "\n        <div ng-bind-html=\"renderHelpFromBackend()\"></div>\n        ";
            this.link = function (s, el, attrs) {
                s.html = '';
                var stage = top.location.href.toLocaleLowerCase();
                s.stage = stage;
                s.renderHelpFromBackend = function () {
                    return _this.$sce.trustAsHtml(s.html);
                };
                // koszyka
                if (stage.indexOf('createoffer') !== -1
                    || stage.indexOf('oferta_otwarta') !== -1
                    || stage.indexOf('oferta_dla_partnera') !== -1
                    || stage.indexOf('process/order') !== -1
                    || stage.indexOf('stacjonarny') !== -1) {
                    s.stage = 'process-order';
                }
                else if (stage.indexOf('offer/get') !== -1
                    || stage.indexOf('process/choose.offer') !== -1) {
                    s.stage = 'process-choose.offer';
                }
                else if (stage.indexOf('offerclientdata/edit') !== -1
                    || stage.indexOf('process/client.data') !== -1) {
                    s.stage = 'process-client.data.loan';
                }
                else if (stage.indexOf('payment/selectpaymentchannel') !== -1
                    || stage.indexOf('process/choose.payment.channel') !== -1) {
                    s.stage = 'process-choose.payment.channel.for';
                    // pobranie rodzaju platnosci
                    var paymentType = (s && s.paymentType) ? ('.' + s.paymentType) : '';
                    s.stage += paymentType;
                }
                else if (stage.indexOf('selfservice/index') !== -1
                    || stage.indexOf('client/service/process') !== -1) {
                    s.stage = 'process-agreement.data.loan';
                }
                // opracowanie partnera
                var partner = 'LEASELINK';
                if (s.user && s.user.Partner) {
                    partner = s.user.Partner;
                }
                else if (s.partner && s.partner.PartnerName) {
                    partner = s.partner.PartnerName;
                }
                else if (s.partner) {
                    partner = s.partner;
                }
                s.processType = 'OperationalLeasing';
                s.logged = false;
                var url = '/personalisation/help/' + partner + '?stage=' + s.stage + '&processType=' + s.processType + '&logged=' + s.logged;
                _this.$http.get(url).then(function (d) {
                    s.html = d.data;
                });
            };
        }
        ;
        FrontHelpDirective.Factory = function () {
            var dir = function ($http, $sce) { return new FrontHelpDirective($http, $sce); };
            dir['$inject'] = ['$http', '$sce'];
            return dir;
        };
        return FrontHelpDirective;
    }());
    clientDirectives.FrontHelpDirective = FrontHelpDirective;
    // pokazanie naglowka z logiem i powitaniem w zaleznosci od partnera 
    var ngShowHeader = (function () {
        function ngShowHeader() {
            this.restrict = "AE";
            this.scope = {
                partner: "="
            };
            this.templateUrl = "/WWW/partials/show.header.directive.html";
        }
        ngShowHeader.Factory = function () {
            var dir = function () { return new ngShowHeader(); };
            dir['$inject'] = [];
            return dir;
        };
        return ngShowHeader;
    }());
    clientDirectives.ngShowHeader = ngShowHeader;
    var ngClientInfoMessageService = (function () {
        function ngClientInfoMessageService($http, $modal, $window) {
            this.$http = $http;
            this.$modal = $modal;
            this.$window = $window;
        }
        ngClientInfoMessageService.prototype.showInfoMessage = function () {
            var _this = this;
            this.$http.get("/process/helper/get-client-notification").then(function (result) {
                var showMessage = result.data.ShowMessage;
                var messageBody = result.data.MessageBody;
                var messageShown = _this.$window.sessionStorage.getItem("clientInfoMessageShown") === "true";
                if (showMessage && !messageShown) {
                    var modalInstance = _this.$modal.open({
                        animation: true,
                        templateUrl: 'clientInfoMessageTemplate',
                        controller: 'ClientInfoMessageCtrl',
                        resolve: {
                            infoMessage: function () {
                                return messageBody;
                            }
                        }
                    });
                    modalInstance.result.then(function () { return _; }, function () {
                        _this.$window.sessionStorage.setItem("clientInfoMessageShown", true);
                    });
                }
            });
        };
        ngClientInfoMessageService.$inject = ['$http', '$modal', '$window'];
        return ngClientInfoMessageService;
    }());
    clientDirectives.ngClientInfoMessageService = ngClientInfoMessageService;
    var ClientInfoMessageDirective = (function () {
        function ClientInfoMessageDirective(ngClientInfoMessageService) {
            this.ngClientInfoMessageService = ngClientInfoMessageService;
            this.restrict = "E";
            this.template = "";
            ngClientInfoMessageService.showInfoMessage();
        }
        ;
        ClientInfoMessageDirective.Factory = function () {
            var dir = function (ngClientInfoMessageService) { return new ClientInfoMessageDirective(ngClientInfoMessageService); };
            dir['$inject'] = ['ngClientInfoMessageService'];
            return dir;
        };
        return ClientInfoMessageDirective;
    }());
    clientDirectives.ClientInfoMessageDirective = ClientInfoMessageDirective;
    var ClientInfoMessageCtrl = (function () {
        function ClientInfoMessageCtrl($scope, $modalInstance, infoMessage) {
            this.$scope = $scope;
            this.$modalInstance = $modalInstance;
            this.infoMessage = infoMessage;
            $scope.infoMessage = infoMessage;
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
        }
        ClientInfoMessageCtrl.$inject = ['$scope', '$modalInstance', 'infoMessage'];
        return ClientInfoMessageCtrl;
    }());
    clientDirectives.ClientInfoMessageCtrl = ClientInfoMessageCtrl;
})(clientDirectives || (clientDirectives = {}));
